import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import { LeRed } from '@lowentry/react-redux';
import { LeUtils, FLOAT_LAX_ANY, FLOAT_LAX, ISSET, STRING, IS_ARRAY, IS_OBJECT, INT_LAX } from '@lowentry/utils';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { useThree, extend, Canvas } from '@react-three/fiber';
import { PerspectiveCamera } from '@react-three/drei';
import { MathUtils, CompressedCubeTexture, CubeTexture, MeshBasicMaterial, LinearSRGBColorSpace, UnsignedByteType, LinearFilter, TextureLoader, Mesh, SphereGeometry } from 'three';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _typeof from '@babel/runtime/helpers/typeof';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { KTX2Loader } from 'three-stdlib';

var cssId$1 = 'mcmhomes_panorama_viewer_default_loading_widget_' + LeUtils.uniqueId();
var css$1 = "\n\t@keyframes ".concat(cssId$1, "_fadein {\n\t\t0% {opacity: 0;}\n\t\t67% {opacity: 0;}\n\t\t100% {opacity: 1;}\n\t}\n\t@keyframes ").concat(cssId$1, "_spin {\n\t\t0% {transform:rotate(0deg);}\n\t\t100% {transform: rotate(360deg);}\n\t}\n");
var PanoramaDefaultLoadingWidget = LeRed.memo(function (props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, css$1), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      animation: cssId$1 + '_fadein 3s ease-in'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-50 -50 100 100",
    preserveAspectRatio: "xMidYMid",
    style: {
      maxWidth: '160px',
      maxHeight: '160px',
      shapeRendering: 'auto',
      display: 'block',
      background: 'transparent'
    }
  }, /*#__PURE__*/React.createElement("circle", {
    strokeDasharray: "164.93361431346415 56.97787143782138",
    r: "35",
    strokeWidth: "5",
    stroke: "#0099e5",
    fill: "none",
    cy: "0",
    cx: "0",
    style: {
      animation: cssId$1 + '_spin 1.5s linear infinite'
    }
  }))));
});

var cssId = 'mcmhomes_panorama_viewer_default_error_widget_' + LeUtils.uniqueId();
var css = "\n\t@keyframes ".concat(cssId, "_fadein {\n\t\t0% {opacity: 0;}\n\t\t100% {opacity: 1;}\n\t}\n\t\n\t.").concat(cssId, "_button_tryagain {\n\t\ttransition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n\t\tbackground: #3690CC;\n\t\tbox-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12);\n\t}\n\t.").concat(cssId, "_button_tryagain:hover {\n\t\tbackground: #23658E;\n\t\tbox-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12);\n\t}\n\t.").concat(cssId, "_button_tryagain:active {\n\t\ttransition: background-color 350ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 350ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n\t\tbackground: #6593AF;\n\t\tbox-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12);\n\t}\n");
var PanoramaDefaultErrorWidget = LeRed.memo(function (_ref) {
  var retry = _ref.retry,
    message = _ref.message,
    reason = _ref.reason;
    _ref.id;
    _ref.data;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, css), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      animation: cssId + '_fadein 0.4s ease-in'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: '100%',
      maxHeight: '100%',
      overflow: 'auto',
      backgroundColor: '#383838',
      padding: '20px 24px',
      borderRadius: '4px',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontSize: '0.875rem',
      boxShadow: '0 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      backgroundColor: '#150B0B',
      color: '#EFC7C8',
      borderRadius: '4px',
      padding: '6px 16px',
      fontSize: '14px',
      fontWeight: '400',
      letterSpacing: '0.01071em',
      lineHeight: '1.42'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    focusable: "false",
    "aria-hidden": "true",
    viewBox: "0 0 24 24",
    style: {
      width: '1em',
      height: '1em',
      color: '#D34038',
      fill: 'currentColor',
      fontSize: '22px',
      margin: '7px 12px 7px 0'
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '8px 0'
    }
  }, message, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), reason)), !!retry && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return retry();
    },
    className: cssId + '_button_tryagain',
    style: {
      marginTop: '16px',
      padding: '11px 22px',
      fontWeight: '600',
      letterSpacing: '0.02857em',
      border: '0',
      borderRadius: '4px',
      cursor: 'pointer'
    }
  }, "TRY AGAIN"))))));
});

var PanoramaControls = LeRed.memo(function (_ref) {
  var minFov = _ref.minFov,
    maxFov = _ref.maxFov,
    calculateFov = _ref.calculateFov,
    onFovChanged = _ref.onFovChanged,
    initialCameraRotation = _ref.initialCameraRotation,
    onCameraRotationChanged = _ref.onCameraRotationChanged,
    givenLookSpeed = _ref.lookSpeed,
    givenLookSpeedX = _ref.lookSpeedX,
    givenLookSpeedY = _ref.lookSpeedY,
    givenZoomSpeed = _ref.zoomSpeed;
  var CUBEMAP_YAW_OFFSET = 90;
  var ROTATION_SPEED = 0.0012;
  var ROTATION_TOUCH_SPEED_MULTIPLIER = 2.0;
  var ROTATION_SLIDING_DISTANCE = 60;
  var ROTATION_DRAG_WHEN_SLIDING = 0.95393;
  var ROTATION_DRAG_WHEN_DRAGGING = 0.9999999995;
  var FOV_SCROLL_SPEED = 0.05;
  var FOV_TOUCH_SPEED_MULTIPLIER = 600;
  var ROTATION_ANIMATION_SPEED = 2;
  var lookSpeed = LeRed.useRef();
  var lookSpeedX = LeRed.useRef();
  var lookSpeedY = LeRed.useRef();
  var zoomSpeed = LeRed.useRef();
  lookSpeed.current = FLOAT_LAX_ANY(givenLookSpeed, 1);
  lookSpeedX.current = FLOAT_LAX_ANY(givenLookSpeedX, 1);
  lookSpeedY.current = FLOAT_LAX_ANY(givenLookSpeedY, 1);
  zoomSpeed.current = FLOAT_LAX_ANY(givenZoomSpeed, 1);
  var cameraMinFov = LeRed.useRef();
  var cameraMaxFov = LeRed.useRef();
  cameraMinFov.current = FLOAT_LAX_ANY(minFov, 1);
  cameraMaxFov.current = FLOAT_LAX_ANY(maxFov, 179);
  var clampFov = function clampFov(fov) {
    return Math.min(cameraMaxFov.current, Math.max(cameraMinFov.current, FLOAT_LAX_ANY(fov, 90)));
  };
  var onCameraRotationChangedRef = LeRed.useRef();
  onCameraRotationChangedRef.current = onCameraRotationChanged;
  var _useThree = useThree(),
    gl = _useThree.gl,
    camera = _useThree.camera,
    invalidate = _useThree.invalidate;
  var isDragging = LeRed.useRef(false);
  var lastMousePosition = LeRed.useRef({
    x: 0,
    y: 0
  });
  var startMousePosition = LeRed.useRef({
    x: 0,
    y: 0
  });
  var startCameraRotation = LeRed.useRef();
  var cameraRotation = LeRed.useRef({
    yaw: 0,
    pitch: 0
  });
  var cameraRotationGoal = LeRed.useRef();
  var lastCameraRotationCallbackParams = LeRed.useRef();
  var cameraRotationSpeed = LeRed.useRef({
    yaw: 0,
    pitch: 0
  });
  var lastCalculatedFovAspectRatio = LeRed.useRef(null);
  var lastCalculatedFov = LeRed.useRef(null);
  if (lastCalculatedFov.current === null) {
    lastCalculatedFov.current = FLOAT_LAX(calculateFov(1));
  }
  var cameraFov = LeRed.useRef(clampFov(lastCalculatedFov.current));
  var lastCameraFovCallbackParams = LeRed.useRef();
  var lastTouchDistance = LeRed.useRef(null);
  var cameraFovRotationSpeedMultiplier = function cameraFovRotationSpeedMultiplier() {
    return cameraFov.current / 90;
  };
  LeRed.useMemo(function () {
    startMousePosition.current = lastMousePosition.current;
    startCameraRotation.current = cameraRotation.current;
  }, [lookSpeed.current, lookSpeedX.current, lookSpeedY.current]);
  var setInitialCameraRotation = function setInitialCameraRotation(rotation, instant) {
    var newRotation = {
      yaw: MathUtils.degToRad(CUBEMAP_YAW_OFFSET - FLOAT_LAX_ANY(rotation === null || rotation === void 0 ? void 0 : rotation.yaw, 0)),
      pitch: MathUtils.clamp(MathUtils.degToRad(FLOAT_LAX_ANY(rotation === null || rotation === void 0 ? void 0 : rotation.pitch, 0)), -Math.PI / 2, Math.PI / 2)
    };
    if (instant) {
      cameraRotation.current = newRotation;
      cameraRotationGoal.current = null;
    } else {
      cameraRotationGoal.current = newRotation;
    }
    isDragging.current = false;
    cameraRotationSpeed.current = {
      yaw: 0,
      pitch: 0
    };
  };
  LeRed.useEffect(function () {
    setInitialCameraRotation(initialCameraRotation, true);
  }, []);
  LeRed.useEffect(function () {
    if (ISSET(initialCameraRotation)) {
      setInitialCameraRotation(initialCameraRotation);
    }
  }, [initialCameraRotation]);
  var handleMouseScroll = LeRed.useCallback(function (event) {
    var _event$stopPropagatio, _event$preventDefault;
    (_event$stopPropagatio = event.stopPropagation) === null || _event$stopPropagatio === void 0 || _event$stopPropagatio.call(event);
    (_event$preventDefault = event.preventDefault) === null || _event$preventDefault === void 0 || _event$preventDefault.call(event);
    cameraFov.current = clampFov(cameraFov.current + FLOAT_LAX_ANY(event.deltaY, 0) * FOV_SCROLL_SPEED * zoomSpeed.current);
  }, []);
  LeRed.useEffectAnimationFrameInterval(function () {
    var _gl$domElement, _gl$domElement2;
    if (!(gl !== null && gl !== void 0 && (_gl$domElement = gl.domElement) !== null && _gl$domElement !== void 0 && _gl$domElement.width) || !(gl !== null && gl !== void 0 && (_gl$domElement2 = gl.domElement) !== null && _gl$domElement2 !== void 0 && _gl$domElement2.height)) {
      return;
    }
    var aspectRatio = gl.domElement.width / gl.domElement.height;
    if (aspectRatio === lastCalculatedFovAspectRatio.current) {
      return;
    }
    lastCalculatedFovAspectRatio.current = aspectRatio;
    var lastCalculatedFovValue = lastCalculatedFov.current;
    lastCalculatedFov.current = FLOAT_LAX(calculateFov(aspectRatio));
    if (lastCalculatedFovValue === lastCalculatedFov.current) {
      return;
    }
    cameraFov.current = clampFov(cameraFov.current * (lastCalculatedFov.current / lastCalculatedFovValue));
  }, [gl === null || gl === void 0 ? void 0 : gl.domElement, calculateFov]);
  LeRed.useEffect(function () {
    lastCalculatedFovAspectRatio.current = null; // force the FOV to be recalculated
  }, [calculateFov]);
  var handleMouseDown = LeRed.useCallback(function (event) {
    var _event$stopPropagatio2, _event, _event$preventDefault2, _event2;
    (_event$stopPropagatio2 = (_event = event).stopPropagation) === null || _event$stopPropagatio2 === void 0 || _event$stopPropagatio2.call(_event);
    (_event$preventDefault2 = (_event2 = event).preventDefault) === null || _event$preventDefault2 === void 0 || _event$preventDefault2.call(_event2);
    if (cameraRotationGoal.current) {
      return;
    }
    if (event.touches) {
      if (event.touches.length > 1) {
        return;
      }
      if (event.touches.length <= 0) {
        handleMouseUp();
        return;
      }
      event = event.touches[0];
    }
    isDragging.current = true;
    lastMousePosition.current = {
      x: event.clientX,
      y: event.clientY
    };
    startMousePosition.current = {
      x: event.clientX,
      y: event.clientY
    };
    startCameraRotation.current = {
      yaw: cameraRotation.current.yaw,
      pitch: cameraRotation.current.pitch
    };
  }, []);
  var handleMouseMove = LeRed.useCallback(function (event) {
    if (!isDragging.current) {
      return;
    }
    var isTouchEvent = !!event.touches;
    if (event.touches) {
      var lastTouchDistanceValue = lastTouchDistance.current;
      lastTouchDistance.current = null;
      if (event.touches.length > 1) {
        if (event.touches.length === 2) {
          lastTouchDistance.current = FLOAT_LAX(Math.hypot(event.touches[0].clientX - event.touches[1].clientX, event.touches[0].clientY - event.touches[1].clientY));
          if (lastTouchDistanceValue !== null) {
            handleMouseScroll({
              deltaY: (lastTouchDistanceValue - lastTouchDistance.current) / lastTouchDistanceValue * FOV_TOUCH_SPEED_MULTIPLIER
            });
          }
        }
        return;
      }
      if (event.touches.length <= 0) {
        handleMouseUp();
        return;
      }
      event = event.touches[0];
    }
    lastMousePosition.current = {
      x: event.clientX,
      y: event.clientY
    };
    var deltaX = event.clientX - startMousePosition.current.x;
    var deltaY = event.clientY - startMousePosition.current.y;
    var newCameraRotation = {
      yaw: startCameraRotation.current.yaw + deltaX * ROTATION_SPEED * (isTouchEvent ? ROTATION_TOUCH_SPEED_MULTIPLIER : 1) * lookSpeed.current * lookSpeedX.current * cameraFovRotationSpeedMultiplier(),
      pitch: MathUtils.clamp(startCameraRotation.current.pitch + deltaY * ROTATION_SPEED * (isTouchEvent ? ROTATION_TOUCH_SPEED_MULTIPLIER : 1) * lookSpeed.current * lookSpeedY.current * cameraFovRotationSpeedMultiplier(), -Math.PI / 2, Math.PI / 2)
    };
    cameraRotationSpeed.current = {
      yaw: (newCameraRotation.yaw - cameraRotation.current.yaw) * ROTATION_SLIDING_DISTANCE,
      pitch: (newCameraRotation.pitch - cameraRotation.current.pitch) * ROTATION_SLIDING_DISTANCE
    };
    cameraRotation.current = newCameraRotation;
  }, []);
  var handleMouseUp = LeRed.useCallback(function (event) {
    isDragging.current = false;
    lastTouchDistance.current = null;
    if (event && event.touches && event.touches.length === 1) {
      handleMouseDown(event);
    }
  }, []);
  LeRed.useEffectAnimationFrameInterval(function (deltaTime) {
    deltaTime = Math.min(0.33, deltaTime); // at least 3 FPS  -  this is to prevent odd behavior (like when the tab is inactive for a long time)

    if (cameraRotationGoal.current) {
      var yawDiff = (MathUtils.radToDeg(cameraRotationGoal.current.yaw) - MathUtils.radToDeg(cameraRotation.current.yaw) + 360000) % 360;
      if (yawDiff > 180) {
        yawDiff -= 360;
      }
      yawDiff = MathUtils.degToRad(yawDiff);
      var pitchDiff = cameraRotationGoal.current.pitch - cameraRotation.current.pitch;
      var distance = Math.sqrt(yawDiff * yawDiff + pitchDiff * pitchDiff);
      var applyDistance = Math.max(distance, 0.0001) * deltaTime * ROTATION_ANIMATION_SPEED;
      if (applyDistance >= distance - 0.8) {
        cameraRotationSpeed.current = {
          yaw: yawDiff * 3,
          pitch: pitchDiff * 3
        };
        cameraRotationGoal.current = null;
      } else {
        var applyDistanceMultiplier = applyDistance / distance;
        cameraRotation.current = {
          yaw: cameraRotation.current.yaw + yawDiff * applyDistanceMultiplier,
          pitch: cameraRotation.current.pitch + pitchDiff * applyDistanceMultiplier
        };
      }
    }
    if (!isDragging.current) {
      cameraRotation.current = {
        yaw: cameraRotation.current.yaw + cameraRotationSpeed.current.yaw * deltaTime,
        pitch: MathUtils.clamp(cameraRotation.current.pitch + cameraRotationSpeed.current.pitch * deltaTime, -Math.PI / 2, Math.PI / 2)
      };
      var drag = Math.pow(1 - ROTATION_DRAG_WHEN_SLIDING, deltaTime);
      cameraRotationSpeed.current.yaw *= drag;
      cameraRotationSpeed.current.pitch *= drag;
    } else {
      var _drag = Math.pow(1 - ROTATION_DRAG_WHEN_DRAGGING, deltaTime);
      cameraRotationSpeed.current.yaw *= _drag;
      cameraRotationSpeed.current.pitch *= _drag;
    }
    if (cameraRotation.current.yaw !== camera.rotation.y || cameraRotation.current.pitch !== camera.rotation.x) {
      camera.rotation.order = 'YXZ'; // yaw first, then pitch
      camera.rotation.y = cameraRotation.current.yaw;
      camera.rotation.x = cameraRotation.current.pitch;
      invalidate();
      if (onCameraRotationChangedRef.current) {
        var yaw = MathUtils.radToDeg(cameraRotation.current.yaw);
        var pitch = MathUtils.radToDeg(cameraRotation.current.pitch);
        yaw = CUBEMAP_YAW_OFFSET - yaw;
        while (yaw < 0) {
          yaw += 360;
        }
        yaw %= 360;
        yaw = Math.round(yaw * 1000) / 1000;
        pitch = Math.round(pitch * 1000) / 1000;
        var roundedRotation = {
          yaw: yaw,
          pitch: pitch
        };
        if (!LeUtils.equals(lastCameraRotationCallbackParams.current, roundedRotation)) {
          var _onCameraRotationChan;
          lastCameraRotationCallbackParams.current = roundedRotation;
          (_onCameraRotationChan = onCameraRotationChangedRef.current) === null || _onCameraRotationChan === void 0 || _onCameraRotationChan.call(onCameraRotationChangedRef, {
            yaw: yaw,
            pitch: pitch
          });
        }
      }
    }
    if ('fov' in camera && cameraFov.current !== camera.fov) {
      camera.fov = FLOAT_LAX_ANY(cameraFov.current, 90);
      camera.updateProjectionMatrix();
      invalidate();
      var roundedFov = Math.round(cameraFov.current * 10) / 10;
      if (!LeUtils.equals(lastCameraFovCallbackParams.current, roundedFov)) {
        lastCameraFovCallbackParams.current = roundedFov;
        onFovChanged === null || onFovChanged === void 0 || onFovChanged(roundedFov);
      }
    }
  }, [camera, invalidate]);
  LeRed.useEffect(function () {
    var domElement = gl.domElement;
    domElement.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    //domElement.addEventListener('mouseleave', handleMouseUp); // stop dragging if the mouse leaves the canvas
    domElement.addEventListener('touchstart', handleMouseDown);
    document.addEventListener('touchmove', handleMouseMove);
    document.addEventListener('touchend', handleMouseUp);
    document.addEventListener('touchcancel', handleMouseUp);
    domElement.addEventListener('wheel', handleMouseScroll);
    return function () {
      domElement.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      //domElement.removeEventListener('mouseleave', handleMouseUp);
      domElement.removeEventListener('touchstart', handleMouseDown);
      document.removeEventListener('touchmove', handleMouseMove);
      document.removeEventListener('touchend', handleMouseUp);
      document.removeEventListener('touchcancel', handleMouseUp);
      domElement.removeEventListener('wheel', handleMouseScroll);
    };
  }, [gl.domElement, handleMouseDown, handleMouseMove, handleMouseUp, handleMouseScroll]);
  return null;
});

var _excluded$3 = ["maskEnvMap"];
function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _dispose = function dispose() {
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }
  objects === null || objects === void 0 || objects.forEach(function (obj) {
    if (Array.isArray(obj)) {
      _dispose.apply(void 0, _toConsumableArray(obj));
      return;
    }
    try {
      obj === null || obj === void 0 || obj.dispose();
    } catch (e) {
      var _obj$constructor;
      console.error('[PanoramaViewer] THREE disposal failed:', _typeof(obj), obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name, e);
    }
  });
};
var loadTextures = function () {
  var ktx2Loader = null;
  var textureLoader = null;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
      var gl, textures, basisTranscoderPath, loader, loadedTextures;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            gl = params.gl, textures = params.textures, basisTranscoderPath = params.basisTranscoderPath;
            if (!(typeof textures[0] !== 'string')) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", textures);
          case 3:
            loader = function () {
              if (textures[0].toLowerCase().endsWith('.ktx2')) {
                if (ktx2Loader === null) {
                  ktx2Loader = new KTX2Loader();
                  ktx2Loader.setTranscoderPath(basisTranscoderPath);
                  ktx2Loader.detectSupport(gl);
                }
                return ktx2Loader;
              }
              if (textureLoader === null) {
                textureLoader = new TextureLoader();
              }
              return textureLoader;
            }();
            _context.next = 6;
            return Promise.all(textures.map(function (url) {
              return loader.loadAsync(url);
            }));
          case 6:
            loadedTextures = _context.sent;
            loadedTextures.forEach(function (tex) {
              tex.colorSpace = LinearSRGBColorSpace;
              tex.anisotropy = 16;
              tex.type = UnsignedByteType;
              tex.minFilter = LinearFilter;
              tex.magFilter = LinearFilter;
              tex.generateMipmaps = false;
              tex.flipY = true;
              tex.needsUpdate = true;
            });
            return _context.abrupt("return", loadedTextures);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}();
var createCubeTexture = function createCubeTexture(textures) {
  var cubeTexture = function () {
    if (textures[0].isCompressedTexture) {
      return new CompressedCubeTexture(textures.map(function (tex) {
        return _objectSpread$3(_objectSpread$3({}, tex.image), tex);
      }), textures[0].format, textures[0].type);
    }
    return new CubeTexture(textures.map(function (tex) {
      return tex.image;
    }));
  }();
  cubeTexture.format = textures[0].format;
  cubeTexture.type = textures[0].type;
  cubeTexture.wrapS = textures[0].wrapS;
  cubeTexture.wrapT = textures[0].wrapT;
  cubeTexture.colorSpace = textures[0].colorSpace;
  cubeTexture.anisotropy = textures[0].anisotropy;
  cubeTexture.minFilter = textures[0].minFilter;
  cubeTexture.magFilter = textures[0].magFilter;
  cubeTexture.generateMipmaps = false;
  cubeTexture.flipY = false;
  cubeTexture.needsUpdate = true;
  return cubeTexture;
};
var createCubeMaterial = function createCubeMaterial(params) {
  var maskEnvMap = params.maskEnvMap,
    props = _objectWithoutProperties(params, _excluded$3);
  var material = new MeshBasicMaterial(props);
  material.onBeforeCompile = function (shader) {
    shader.uniforms.maskEnvMap = {
      value: maskEnvMap
    };
    var fragmentShaderLower = shader.fragmentShader.toLowerCase();
    var mainStartIndex = fragmentShaderLower.indexOf('void main()'.toLowerCase());
    if (mainStartIndex < 0) {
      console.error('[PanoramaViewer] createCubeMaterial error: shader fragment "void main()" not found', shader.fragmentShader);
      return;
    }
    var envmapFragmentStartIndex = fragmentShaderLower.indexOf('#include <envmap_fragment>'.toLowerCase());
    if (envmapFragmentStartIndex < 0) {
      console.error('[PanoramaViewer] createCubeMaterial error: shader fragment "#include <envmap_fragment>" not found', shader.fragmentShader);
      return;
    }
    var envmapFragmentEndIndex = fragmentShaderLower.indexOf('>'.toLowerCase(), envmapFragmentStartIndex) + 1;
    var startToMain = shader.fragmentShader.substring(0, mainStartIndex);
    var mainToEndEnvmapFragment = shader.fragmentShader.substring(mainStartIndex, envmapFragmentEndIndex);
    var endEnvmapFragmentToEnd = shader.fragmentShader.substring(envmapFragmentEndIndex);
    shader.fragmentShader = startToMain + "\n\t\t\t" + (!maskEnvMap ? "" : "uniform samplerCube maskEnvMap;") + "\n\t\t\t" + mainToEndEnvmapFragment + "\n\t\t\t\tvec4 maskColor = " + (!maskEnvMap ? "vec4(1,1,1,1)" : "textureCube(maskEnvMap, envMapRotation * vec3(flipEnvMap * reflectVec.x, reflectVec.yz))") + ";\n\t\t\t\tdiffuseColor.a *= maskColor.r;\n\t\t\t" + endEnvmapFragmentToEnd;
  };
  return material;
};
var getTexturePathsOfBasePath = function getTexturePathsOfBasePath(params) {
  var basePath = params.basePath,
    _params$type = params.type,
    type = _params$type === void 0 ? 'ktx2' : _params$type;
  if (!basePath) {
    return null;
  }
  return [[basePath + '/0.' + type // low-res
  ], [basePath + '/1r.' + type,
  // right
  basePath + '/1l.' + type,
  // left
  basePath + '/1d.' + type,
  // down
  basePath + '/1u.' + type,
  // up
  basePath + '/1f.' + type,
  // front
  basePath + '/1b.' + type // back
  ]];
};
var loadMultiresTexture = function loadMultiresTexture(params) {
  var gl = params.gl,
    basePath = params.basePath,
    maskBasePath = params.maskBasePath,
    type = params.type,
    basisTranscoderPath = params.basisTranscoderPath,
    givenMinimumLoadTime = params.minimumLoadTime,
    onLoadingLevelDone = params.onLoadingLevelDone,
    onLoadingLevelFail = params.onLoadingLevelFail;
  var minimumLoadTime = FLOAT_LAX(givenMinimumLoadTime, 0);
  var textures = getTexturePathsOfBasePath({
    basePath: basePath,
    type: type
  });
  var maskTextures = getTexturePathsOfBasePath({
    basePath: maskBasePath,
    type: type
  });
  if (!gl || !textures) {
    return;
  }
  var listeners = [];
  var allLoadTextures = [];
  var lastLoadedLevel = -1;
  var lastLoadedTextures = null;
  var lastLoadedMaskTextures = null;
  var cancel = false;
  var newLoadedTextures = null;
  var newLoadedMaskTextures = null;
  var removeListener = function removeListener(key) {
    listeners = listeners.filter(function (listener) {
      return listener.key !== key;
    });
  };
  var addListener = function addListener(_ref2) {
    var onDone = _ref2.onDone,
      onFail = _ref2.onFail;
    var key = LeUtils.uniqueId();
    listeners.push({
      key: key,
      onDone: onDone,
      onFail: onFail
    });
    if (lastLoadedTextures) {
      try {
        onDone === null || onDone === void 0 || onDone({
          level: lastLoadedLevel,
          textures: lastLoadedTextures,
          maskTextures: lastLoadedMaskTextures
        });
      } catch (e) {
        console.error('[PanoramaViewer] loadMultiresTexture listener.onDone failed:', e);
      }
    }
    return {
      remove: function remove() {
        return removeListener(key);
      }
    };
  };
  var disposeLoadTextures = function disposeLoadTextures() {
    cancel = true;
    _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _dispose.apply(void 0, _toConsumableArray(allLoadTextures));
            allLoadTextures = [];
            lastLoadedTextures = null;
            lastLoadedMaskTextures = null;
            _context2.t0 = _dispose;
            _context2.next = 7;
            return newLoadedTextures;
          case 7:
            _context2.t1 = _context2.sent;
            _context2.next = 10;
            return newLoadedMaskTextures;
          case 10:
            _context2.t2 = _context2.sent;
            (0, _context2.t0)(_context2.t1, _context2.t2);
            newLoadedTextures = null;
            newLoadedMaskTextures = null;
            _dispose.apply(void 0, _toConsumableArray(allLoadTextures));
            allLoadTextures = [];
            lastLoadedTextures = null;
            lastLoadedMaskTextures = null;
          case 18:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  };
  var _loadLevel = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(level) {
      var attempt,
        error,
        _args3 = arguments;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            attempt = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 1;
            _context3.prev = 1;
            if (!cancel) {
              _context3.next = 4;
              break;
            }
            return _context3.abrupt("return");
          case 4:
            if (ISSET(textures[level])) {
              _context3.next = 6;
              break;
            }
            return _context3.abrupt("return");
          case 6:
            newLoadedTextures = loadTextures({
              gl: gl,
              textures: textures[level],
              basisTranscoderPath: basisTranscoderPath
            });
            newLoadedMaskTextures = !maskTextures ? null : loadTextures({
              gl: gl,
              textures: maskTextures[level],
              basisTranscoderPath: basisTranscoderPath
            });
            error = null;
            _context3.prev = 9;
            _context3.next = 12;
            return newLoadedTextures;
          case 12:
            newLoadedTextures = _context3.sent;
            _context3.next = 19;
            break;
          case 15:
            _context3.prev = 15;
            _context3.t0 = _context3["catch"](9);
            newLoadedTextures = null;
            error = _context3.t0;
          case 19:
            _context3.prev = 19;
            _context3.next = 22;
            return newLoadedMaskTextures;
          case 22:
            newLoadedMaskTextures = _context3.sent;
            _context3.next = 29;
            break;
          case 25:
            _context3.prev = 25;
            _context3.t1 = _context3["catch"](19);
            newLoadedMaskTextures = null;
            error = _context3.t1;
          case 29:
            if (!error) {
              _context3.next = 32;
              break;
            }
            _dispose(newLoadedTextures, newLoadedMaskTextures);
            throw error;
          case 32:
            if (!cancel) {
              _context3.next = 35;
              break;
            }
            _dispose(newLoadedTextures, newLoadedMaskTextures);
            return _context3.abrupt("return");
          case 35:
            allLoadTextures.push(newLoadedTextures);
            allLoadTextures.push(newLoadedMaskTextures);
            lastLoadedLevel = level;
            lastLoadedTextures = newLoadedTextures;
            lastLoadedMaskTextures = newLoadedMaskTextures;
            _context3.prev = 40;
            _context3.next = 43;
            return onLoadingLevelDone === null || onLoadingLevelDone === void 0 ? void 0 : onLoadingLevelDone({
              level: level,
              textures: newLoadedTextures,
              maskTextures: newLoadedMaskTextures
            });
          case 43:
            _context3.next = 48;
            break;
          case 45:
            _context3.prev = 45;
            _context3.t2 = _context3["catch"](40);
            console.error('[PanoramaViewer] loadMultiresTexture onLoadingLevelDone failed:', _context3.t2);
          case 48:
            LeUtils.each(listeners, function (listener) {
              try {
                var _listener$onDone;
                listener === null || listener === void 0 || (_listener$onDone = listener.onDone) === null || _listener$onDone === void 0 || _listener$onDone.call(listener, {
                  level: lastLoadedLevel,
                  textures: lastLoadedTextures,
                  maskTextures: lastLoadedMaskTextures
                });
              } catch (e) {
                console.error('[PanoramaViewer] loadMultiresTexture listener.onDone failed:', e);
              }
            });
            _context3.next = 51;
            return _loadLevel(level + 1);
          case 51:
            _context3.next = 74;
            break;
          case 53:
            _context3.prev = 53;
            _context3.t3 = _context3["catch"](1);
            if (!cancel) {
              _context3.next = 57;
              break;
            }
            return _context3.abrupt("return");
          case 57:
            if (!(attempt <= 3)) {
              _context3.next = 63;
              break;
            }
            _context3.next = 60;
            return LeUtils.promiseTimeout(500);
          case 60:
            _context3.next = 62;
            return _loadLevel(level, attempt + 1);
          case 62:
            return _context3.abrupt("return");
          case 63:
            cancel = true;
            console.error('[PanoramaViewer] loadMultiresTexture texture loading failed:', _context3.t3);
            _context3.prev = 65;
            _context3.next = 68;
            return onLoadingLevelFail === null || onLoadingLevelFail === void 0 ? void 0 : onLoadingLevelFail({
              level: level,
              error: _context3.t3
            });
          case 68:
            _context3.next = 73;
            break;
          case 70:
            _context3.prev = 70;
            _context3.t4 = _context3["catch"](65);
            console.error('[PanoramaViewer] loadMultiresTexture onLoadingLevelFail failed:', _context3.t4);
          case 73:
            LeUtils.each(listeners, function (listener) {
              try {
                var _listener$onFail;
                listener === null || listener === void 0 || (_listener$onFail = listener.onFail) === null || _listener$onFail === void 0 || _listener$onFail.call(listener, {
                  level: lastLoadedLevel,
                  error: _context3.t3
                });
              } catch (e) {
                console.error('[PanoramaViewer] loadMultiresTexture listener.onFail failed:', e);
              }
            });
          case 74:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 53], [9, 15], [19, 25], [40, 45], [65, 70]]);
    }));
    return function loadLevel(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  // noinspection JSIgnoredPromiseFromCall
  _loadLevel(0);
  var minimumTimeWaited = minimumLoadTime <= 0;
  if (!minimumTimeWaited) {
    setTimeout(function () {
      minimumTimeWaited = true;
    }, minimumLoadTime);
  }
  return {
    loaderId: LeUtils.uniqueId(),
    dispose: disposeLoadTextures,
    isReady: function isReady() {
      var minLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return cancel || lastLoadedLevel >= minLevel && minimumTimeWaited;
    },
    addListener: addListener
  };
};

function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
extend({
  Mesh: Mesh,
  MeshBasicMaterial: MeshBasicMaterial
});
var DEFAULT_OBJECT_PARAMS = {
  matrixAutoUpdate: false,
  receiveShadow: false,
  castShadow: false
};
var DEFAULT_MATERIAL_PARAMS = {
  visible: false,
  transparent: true,
  depthTest: false,
  depthWrite: false,
  stencilWrite: false
};
var PanoramaRenderingLayerSphere = LeRed.memo(function (_ref) {
  var renderOrder = _ref.renderOrder,
    radius = _ref.radius,
    textures = _ref.textures,
    maskTextures = _ref.maskTextures,
    givenOpacity = _ref.opacity;
  var opacity = FLOAT_LAX_ANY(givenOpacity, 1);
  var _useThree = useThree(),
    gl = _useThree.gl;
  var _LeRed$useState = LeRed.useState(null),
    _LeRed$useState2 = _slicedToArray(_LeRed$useState, 2),
    sphereMaterial = _LeRed$useState2[0],
    setSphereMaterial = _LeRed$useState2[1];
  var _LeRed$useState3 = LeRed.useState({}),
    _LeRed$useState4 = _slicedToArray(_LeRed$useState3, 2),
    sphereMaterialProps = _LeRed$useState4[0],
    setSphereMaterialProps = _LeRed$useState4[1];
  var geometry = LeRed.useMemo(function () {
    var geom = new SphereGeometry(radius, 60, 40);
    geom.scale(-1, 1, 1);
    return geom;
  }, [radius]);
  LeRed.useEffect(function () {
    if (!gl || !textures) {
      setSphereMaterialProps({});
      return;
    }
    var cubeTexture = null;
    var maskCubeTexture = null;
    var material = null;
    try {
      if (textures.length === 1) {
        setSphereMaterialProps({
          visible: true,
          map: textures[0],
          alphaMap: !maskTextures ? null : maskTextures[0]
        });
        return;
      }
      cubeTexture = createCubeTexture(textures);
      if (!maskTextures) {
        setSphereMaterialProps({
          visible: true,
          envMap: cubeTexture
        });
        return;
      }
      maskCubeTexture = !maskTextures ? null : createCubeTexture(maskTextures);
      material = createCubeMaterial(_objectSpread$2(_objectSpread$2({}, DEFAULT_MATERIAL_PARAMS), {}, {
        visible: true,
        envMap: cubeTexture,
        maskEnvMap: maskCubeTexture
      }));
      setSphereMaterial(material);
    } catch (e) {
      console.error('[PanoramaViewer] PanoramaSphereWithLoadedTextures cube texture creation failed:', e);
    }
    return function () {
      setSphereMaterial(null);
      _dispose(cubeTexture, maskCubeTexture, material);
    };
  }, [gl, textures, maskTextures]);
  return /*#__PURE__*/React.createElement("mesh", _extends({}, DEFAULT_OBJECT_PARAMS, {
    geometry: geometry,
    renderOrder: renderOrder
  }), !!sphereMaterial && /*#__PURE__*/React.createElement("primitive", _extends({}, DEFAULT_MATERIAL_PARAMS, {
    object: sphereMaterial,
    visible: true,
    opacity: opacity
  })), !sphereMaterial && /*#__PURE__*/React.createElement("meshBasicMaterial", _extends({}, DEFAULT_MATERIAL_PARAMS, sphereMaterialProps, {
    opacity: opacity
  })));
});

var useFadeoutAnimation = function useFadeoutAnimation(params) {
  var visible = params.visible,
    delay = params.delay,
    duration = params.duration,
    decayFactor = params.decayFactor;
  var opacityRef = LeRed.useRef(1);
  var _LeRed$useState = LeRed.useState(1),
    _LeRed$useState2 = _slicedToArray(_LeRed$useState, 2),
    opacity = _LeRed$useState2[0],
    setOpacity = _LeRed$useState2[1];
  var delayTimePassedRef = LeRed.useRef(0);
  LeRed.useEffect(function () {
    if (visible) {
      delayTimePassedRef.current = 0;
      opacityRef.current = 1;
      setOpacity(1);
      return;
    }
    if (opacityRef.current <= 0) {
      return;
    }
    var timer = null;
    var startTime = performance.now();
    var stopTimer = function stopTimer() {
      delayTimePassedRef.current += performance.now() - startTime;
      try {
        var _timer;
        (_timer = timer) === null || _timer === void 0 || _timer.remove();
        timer = null;
      } catch (e) {
        console.error('[PanoramaViewer] fadeout animation timer removal failed:', e);
      }
    };
    timer = LeUtils.setTimeout(function () {
      if (!timer) {
        return;
      }
      timer = LeUtils.setAnimationFrameInterval(function (deltaTime) {
        if (ISSET(decayFactor)) {
          var before = opacityRef.current;
          var after = before * Math.pow(FLOAT_LAX(decayFactor), deltaTime);
          var dif = Math.max(before - after, deltaTime / 2);
          opacityRef.current -= dif;
        } else {
          opacityRef.current -= deltaTime / (FLOAT_LAX_ANY(duration, 1000) / 1000);
        }
        if (opacityRef.current < 0.001) {
          opacityRef.current = 0;
        }
        setOpacity(opacityRef.current);
        if (opacityRef.current <= 0) {
          stopTimer();
        }
      });
    }, Math.max(0, FLOAT_LAX(delay) - delayTimePassedRef.current));
    return stopTimer;
  }, [visible, delay, duration, decayFactor]);
  return {
    opacity: opacity
  };
};

var FADEOUT_DELAY_MS$1 = 200;
var FADEOUT_DURATION_MS$1 = 800;
var FADEOUT_DURATION_DECAY_FACTOR$1 = Math.pow(0.01, 1 / (FADEOUT_DURATION_MS$1 / 1000));
var PanoramaRenderingLayerMinimumLoadTime = FADEOUT_DELAY_MS$1;
var PanoramaRenderingLayerFullFadeTimeMs = FADEOUT_DURATION_MS$1 + 200;
var PanoramaRenderingLayer = LeRed.memo(function (_ref) {
  var src = _ref.src,
    visible = _ref.visible,
    renderOrder = _ref.renderOrder;
  var _LeRed$useState = LeRed.useState(LeUtils.uniqueId()),
    _LeRed$useState2 = _slicedToArray(_LeRed$useState, 2);
    _LeRed$useState2[0];
    var setRenderId = _LeRed$useState2[1];
  var resolutionsRef = LeRed.useRef([]);
  LeRed.useEffect(function () {
    if (!visible) {
      return;
    }
    return src.addListener({
      onDone: function onDone(_ref2) {
        var textures = _ref2.textures,
          maskTextures = _ref2.maskTextures;
        var fadeoutDuration = null;
        var fadeoutDecayFactor = FADEOUT_DURATION_DECAY_FACTOR$1;
        LeUtils.each(resolutionsRef.current, function (resolution) {
          return resolution.visible = false;
        });
        resolutionsRef.current.unshift({
          visible: true,
          props: {
            key: LeUtils.uniqueId(),
            textures: textures,
            maskTextures: maskTextures,
            fadeoutDuration: fadeoutDuration,
            fadeoutDecayFactor: fadeoutDecayFactor
          }
        });
        setRenderId(LeUtils.uniqueId());
      }
    }).remove;
  }, [src, visible]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, LeUtils.mapToArray(resolutionsRef.current, function (resolution, index) {
    return /*#__PURE__*/React.createElement(PanoramaRenderingLayerResolution, _extends({}, resolution.props, {
      visible: visible && resolution.visible,
      renderOrder: renderOrder + index / resolutionsRef.current.length
    }));
  }));
});
var PanoramaRenderingLayerResolution = LeRed.memo(function (_ref3) {
  _ref3.src;
    var visible = _ref3.visible,
    fadeoutDuration = _ref3.fadeoutDuration,
    fadeoutDecayFactor = _ref3.fadeoutDecayFactor,
    renderOrder = _ref3.renderOrder,
    textures = _ref3.textures,
    maskTextures = _ref3.maskTextures;
  var _useFadeoutAnimation = useFadeoutAnimation({
      visible: visible,
      duration: fadeoutDuration,
      decayFactor: fadeoutDecayFactor
    }),
    opacity = _useFadeoutAnimation.opacity;
  if (opacity <= 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PanoramaRenderingLayerSphere, {
    renderOrder: renderOrder,
    opacity: opacity,
    radius: 1000,
    textures: textures,
    maskTextures: maskTextures
  }));
});

var PanoramaRendererLayers = LeRed.memo(function (_ref) {
  var src = _ref.src;
  var currentLayersRef = LeRed.useRef([]);
  var _LeRed$useState = LeRed.useState([]),
    _LeRed$useState2 = _slicedToArray(_LeRed$useState, 2),
    currentLayers = _LeRed$useState2[0],
    setCurrentLayers = _LeRed$useState2[1];
  LeRed.useEffect(function () {
    var now = performance.now();

    /** create a lookup table **/
    var newSrc = {};
    LeUtils.each(src, function (item, index) {
      newSrc[item.basePath] = item;
    });

    /** dispose layers that are not in the new src **/
    LeUtils.each(currentLayersRef.current, function (layer, index) {
      if (!layer.visible) {
        /** already being disposed **/
        return;
      }
      if (newSrc[layer.src.basePath]) {
        /** exists, don't dispose **/
        delete newSrc[layer.src.basePath];
        return;
      }

      /** removed, dispose **/

      layer.visible = false;
      layer.visibleLastTime = now;
      LeUtils.setTimeout(function () {
        currentLayersRef.current = currentLayersRef.current.filter(function (item) {
          return item.key !== layer.key;
        });
        setCurrentLayers(_toConsumableArray(currentLayersRef.current));
        LeUtils.setAnimationFrameTimeout(function () {
          layer.src.dispose();
        }, 10);
      }, PanoramaRenderingLayerFullFadeTimeMs);
    });

    /** add new layers **/
    LeUtils.each(newSrc, function (item, basePath) {
      currentLayersRef.current.push({
        key: LeUtils.uniqueId(),
        time: now,
        src: item,
        visible: true
      });
    });

    /** sort the layers, in render order **/
    /** the one that is fading out, has to be rendered on top (rendered later) **/
    var A = -1; // render a first, meaning it will be rendered below B
    var B = 1; // render b first, meaning it will be rendered below A
    currentLayersRef.current.sort(function (a, b) {
      if (a.src.styleIndex !== b.src.styleIndex || a.src.locationIndex !== b.src.locationIndex) {
        if (!a.visible && !b.visible) {
          if (a.visibleLastTime > b.visibleLastTime) {
            return A;
          }
          if (a.visibleLastTime < b.visibleLastTime) {
            return B;
          }
        } else {
          if (!a.visible) {
            return B;
          }
          if (!b.visible) {
            return A;
          }
        }
        if (a.time > b.time) {
          return A;
        }
        if (a.time < b.time) {
          return B;
        }
        return 0;
      }
      if (a.src.layerRenderOrder < b.src.layerRenderOrder) {
        return A;
      }
      if (a.src.layerRenderOrder > b.src.layerRenderOrder) {
        return B;
      }
      if (!a.visible && !b.visible) {
        if (a.visibleLastTime > b.visibleLastTime) {
          return A;
        }
        if (a.visibleLastTime < b.visibleLastTime) {
          return B;
        }
      } else {
        if (!a.visible) {
          return B;
        }
        if (!b.visible) {
          return A;
        }
      }
      if (a.time > b.time) {
        return A;
      }
      if (a.time < b.time) {
        return B;
      }
      return 0;
    });
    setCurrentLayers(_toConsumableArray(currentLayersRef.current));
  }, [src]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, LeUtils.mapToArray(currentLayers, function (layer, index) {
    return /*#__PURE__*/React.createElement(PanoramaRenderingLayer, {
      key: layer.key,
      src: layer.src,
      visible: layer.visible,
      renderOrder: index
    });
  }));
});

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PanoramaRendererTexturePreloader = LeRed.memo(function (_ref) {
  var src = _ref.src,
    homeId = _ref.homeId,
    host = _ref.host,
    homeUrl = _ref.homeUrl,
    basisTranscoderPath = _ref.basisTranscoderPath,
    setError = _ref.setError,
    setLoading = _ref.setLoading;
  var _useThree = useThree(),
    gl = _useThree.gl;
  var currentLayersRef = LeRed.useRef([]);
  var _LeRed$useState = LeRed.useState([]),
    _LeRed$useState2 = _slicedToArray(_LeRed$useState, 2),
    currentLayers = _LeRed$useState2[0],
    setCurrentLayers = _LeRed$useState2[1];
  var readyLayersRef = LeRed.useRef([]);
  var _LeRed$useState3 = LeRed.useState([]),
    _LeRed$useState4 = _slicedToArray(_LeRed$useState3, 2),
    readyLayers = _LeRed$useState4[0],
    setReadyLayers = _LeRed$useState4[1];
  LeRed.useEffect(function () {
    if (!gl) {
      return;
    }

    /** create a lookup table **/
    var newSrc = {};
    LeUtils.each(src, function (item, index) {
      newSrc[item.basePath] = item;
    });

    /** dispose layers that are not in the new src **/
    LeUtils.each(currentLayersRef.current, function (layer, index) {
      if (newSrc[layer.src.basePath]) {
        /** exists, don't dispose **/
        delete newSrc[layer.src.basePath];
        return;
      }

      /** removed, dispose **/
      layer.removed = true;
      currentLayersRef.current = currentLayersRef.current.filter(function (item) {
        return item.key !== layer.key;
      });

      /** if not in readyLayers, dispose textures now **/
      if (!readyLayersRef.current.find(function (item) {
        return item.key === layer.key;
      })) {
        layer.src.dispose();
      }
    });

    /** add new layers **/
    LeUtils.each(newSrc, function (item, basePath) {
      var layer = {
        key: LeUtils.uniqueId()
      };
      var onLoadingError = function onLoadingError(_ref2) {
        var level = _ref2.level,
          error = _ref2.error;
        if (!layer.removed && level <= 0) {
          setError({
            canRetry: true,
            id: 'could-not-load-home',
            message: 'Couldn\'t load the home: ' + homeId,
            reason: STRING(LeUtils.purgeErrorMessage(error)),
            data: {
              homeId: homeId,
              host: host,
              homeUrl: homeUrl
            }
          });
        }
      };
      var loader = loadMultiresTexture({
        gl: gl,
        basePath: item.basePath,
        maskBasePath: item.maskBasePath,
        basisTranscoderPath: basisTranscoderPath,
        minimumLoadTime: readyLayersRef.current.length <= 0 ? 0 : PanoramaRenderingLayerMinimumLoadTime,
        onLoadingLevelFail: onLoadingError
      });
      if (loader) {
        layer.src = _objectSpread$1(_objectSpread$1({}, item), loader);
        currentLayersRef.current.push(layer);
      }
    });
    setCurrentLayers(_toConsumableArray(currentLayersRef.current));
  }, [gl, src]);
  LeRed.useEffect(function () {
    var timer = LeUtils.setAnimationFrameInterval(function () {
      var ready = true;
      LeUtils.each(currentLayers, function (layer, index) {
        if (!layer.src.isReady(0)) {
          ready = false;
          return false;
        }
      });
      if (ready) {
        readyLayersRef.current = _toConsumableArray(currentLayers);
        setReadyLayers(readyLayersRef.current);
        timer.remove();
      }
    });
    return timer.remove;
  }, [currentLayers]);
  LeRed.useEffect(function () {
    setLoading(readyLayers.length <= 0);
  }, [readyLayers.length <= 0]);
  LeRed.useEffect(function () {
    return function () {
      /** cleanup **/
      LeUtils.each(currentLayersRef.current, function (layer, index) {
        layer.removed = true;
        layer.src.dispose();
      });
      currentLayersRef.current = [];
      readyLayersRef.current = [];
      setCurrentLayers([]);
      setReadyLayers([]);
    };
  }, []);
  if (readyLayers.length <= 0) {
    return;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PanoramaRendererLayers, {
    src: LeUtils.mapToArray(readyLayers, function (layer) {
      return layer.src;
    })
  }));
});

var getSelectedVariationIndexesBySku = function getSelectedVariationIndexesBySku(variationGroups, skus) {
  var selectedVariationIndexes = LeUtils.mapToArray(variationGroups, function () {
    return 0;
  });
  if (IS_ARRAY(skus)) {
    LeUtils.each(skus, function (sku, groupIndex) {
      var skuFound = false;
      LeUtils.each(variationGroups, function (group, groupIndex) {
        var variationIndex = LeUtils.findIndex(group === null || group === void 0 ? void 0 : group.variations, function (variation) {
          return (variation === null || variation === void 0 ? void 0 : variation.sku) === sku;
        });
        if (ISSET(variationIndex)) {
          selectedVariationIndexes[groupIndex] = variationIndex;
          skuFound = true;
        }
      });
      if (!skuFound) {
        console.warn('[PanoramaViewer] SKU not found:', sku);
      }
    });
  } else if (IS_OBJECT(skus)) {
    LeUtils.each(skus, function (sku, groupId) {
      var groupIndex = LeUtils.findIndex(variationGroups, function (variationGroup) {
        return (variationGroup === null || variationGroup === void 0 ? void 0 : variationGroup.groupId) === groupId;
      });
      if (groupIndex !== null) {
        var group = variationGroups[groupIndex];
        var variationIndex = LeUtils.findIndex(group === null || group === void 0 ? void 0 : group.variations, function (variation) {
          return (variation === null || variation === void 0 ? void 0 : variation.sku) === sku;
        });
        if (ISSET(variationIndex)) {
          selectedVariationIndexes[groupIndex] = variationIndex;
        } else {
          console.warn('[PanoramaViewer] SKU not found in group:', sku, group);
        }
      } else {
        console.warn('[PanoramaViewer] SKU Group ID not found:', groupId);
      }
    });
  } else if (ISSET(skus)) {
    console.warn('[PanoramaViewer] Invalid SKUs:', skus);
  }
  return selectedVariationIndexes;
};
var getTexturePathsToRender = function getTexturePathsToRender(variationGroups, selectedVariationIndexes, locationVariationGroups, styleIndex, locationIndex, homeUrl) {
  var result = [];
  var variationIndexesForLocation = [];
  var locationVariationIndexIndexed = {};
  var locationVariationGroupsIndexed = {};

  /** add full render **/
  LeUtils.each(variationGroups, function (group, groupIndex) {
    var locationVariationIndex = LeUtils.findIndex(locationVariationGroups, function (locationVariationGroup) {
      return (locationVariationGroup === null || locationVariationGroup === void 0 ? void 0 : locationVariationGroup.groupId) === (group === null || group === void 0 ? void 0 : group.groupId);
    });
    var locationVariationGroup = locationVariationIndex === null ? null : locationVariationGroups === null || locationVariationGroups === void 0 ? void 0 : locationVariationGroups[locationVariationIndex];
    locationVariationIndexIndexed[group === null || group === void 0 ? void 0 : group.groupId] = locationVariationIndex;
    locationVariationGroupsIndexed[group === null || group === void 0 ? void 0 : group.groupId] = locationVariationGroup;
    if (locationVariationGroup && !(locationVariationGroup !== null && locationVariationGroup !== void 0 && locationVariationGroup.layer)) {
      variationIndexesForLocation.push(INT_LAX(selectedVariationIndexes[groupIndex]));
    } else {
      variationIndexesForLocation.push(0);
    }
  });
  result.push({
    styleIndex: styleIndex,
    locationIndex: locationIndex,
    layerRenderOrder: 0,
    basePath: homeUrl + 'img_' + styleIndex + '_' + locationIndex + (variationIndexesForLocation.length <= 0 ? '' : '_' + variationIndexesForLocation.join('_'))
  });

  /** add layers **/
  LeUtils.each(variationGroups, function (layerGroup, layerGroupIndex) {
    var locationVariationGroup = locationVariationGroupsIndexed[layerGroup === null || layerGroup === void 0 ? void 0 : layerGroup.groupId];
    if (!locationVariationGroup || !(locationVariationGroup !== null && locationVariationGroup !== void 0 && locationVariationGroup.layer)) {
      return;
    }
    var locationVariationIndex = locationVariationIndexIndexed[layerGroup === null || layerGroup === void 0 ? void 0 : layerGroup.groupId];
    variationIndexesForLocation = [];
    LeUtils.each(variationGroups, function (group, groupIndex) {
      if ((layerGroup === null || layerGroup === void 0 ? void 0 : layerGroup.groupId) === (group === null || group === void 0 ? void 0 : group.groupId) || LeUtils.contains(locationVariationGroup === null || locationVariationGroup === void 0 ? void 0 : locationVariationGroup.layerDependencyGroupIds, group === null || group === void 0 ? void 0 : group.groupId)) {
        variationIndexesForLocation.push(INT_LAX(selectedVariationIndexes[groupIndex]));
      } else {
        variationIndexesForLocation.push(0);
      }
    });
    var colorPath = 'img_' + styleIndex + '_' + locationIndex + '_' + layerGroupIndex + 'c' + (variationIndexesForLocation.length <= 0 ? '' : '_' + variationIndexesForLocation.join('_'));
    var maskPath = 'img_' + styleIndex + '_' + locationIndex + '_' + layerGroupIndex + 'm' + (variationIndexesForLocation.length <= 0 ? '' : '_' + variationIndexesForLocation.join('_'));
    result.push({
      styleIndex: styleIndex,
      locationIndex: locationIndex,
      layerRenderOrder: locationVariationIndex + 1,
      basePath: homeUrl + colorPath,
      maskBasePath: homeUrl + maskPath
    });
  });
  return result;
};

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FADEOUT_DELAY_MS = 200;
var FADEOUT_DURATION_MS = 800;
var FADEOUT_DURATION_DECAY_FACTOR = Math.pow(0.01, 1 / (FADEOUT_DURATION_MS / 1000));
var PanoramaRenderer = LeRed.memo(function (props) {
  props.getErrorWidget;
    var getLoadingWidget = props.getLoadingWidget;
  var _LeRed$useState = LeRed.useState(LeUtils.uniqueId()),
    _LeRed$useState2 = _slicedToArray(_LeRed$useState, 2);
    _LeRed$useState2[0];
    var setRenderId = _LeRed$useState2[1];
  var _LeRed$useState3 = LeRed.useState(true),
    _LeRed$useState4 = _slicedToArray(_LeRed$useState3, 2),
    initialLoading = _LeRed$useState4[0],
    setInitialLoading = _LeRed$useState4[1];
  var layersRef = LeRed.useRef([]);
  LeRed.useMemo(function () {
    var key = LeUtils.uniqueId();
    var setLoading = function setLoading(isLoading) {
      if (isLoading) {
        return;
      }
      var layer = LeUtils.find(layersRef.current, function (layer) {
        return layer.props.key === key;
      });
      if (layer && layer.props.loading) {
        layer.props.loading = false;
        setRenderId(LeUtils.uniqueId());
        setInitialLoading(false);
        LeUtils.setTimeout(function () {
          var index = LeUtils.findIndex(layersRef.current, function (layer) {
            return layer.props.key === key;
          });
          if (index > 0) {
            layersRef.current.splice(0, index);
            setRenderId(LeUtils.uniqueId());
          }
        }, FADEOUT_DELAY_MS + FADEOUT_DURATION_MS + 200);
      }
    };
    layersRef.current.push({
      props: {
        key: key,
        loading: true,
        setLoading: setLoading
      },
      givenProps: props
    });
  }, [props === null || props === void 0 ? void 0 : props.homeUrl, props === null || props === void 0 ? void 0 : props.locationId]);
  LeRed.useMemo(function () {
    LeUtils.each(layersRef.current, function (layer) {
      if (layer.givenProps.homeUrl === props.homeUrl && layer.givenProps.locationId === props.locationId) {
        layer.givenProps = props;
      }
    });
  }, [props]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!initialLoading && getLoadingWidget(), /*#__PURE__*/React.createElement("div", {
    style: _objectSpread({
      position: 'relative',
      width: '100%',
      height: '100%',
      overflow: 'hidden'
    }, !initialLoading ? {} : {
      width: '1px',
      height: '1px',
      opacity: '0'
    })
  }, LeUtils.mapToArray(layersRef.current, function (layer) {
    return /*#__PURE__*/React.createElement(PanoramaRendererAtLocation, _extends({}, layer.givenProps, layer.props));
  })));
});
var PanoramaRendererAtLocation = LeRed.memo(function (_ref) {
  var _styles$styleIndex, _locations$locationIn2, _locations$locationIn3, _locations$locationIn4;
  var loading = _ref.loading,
    setLoading = _ref.setLoading,
    homeId = _ref.homeId,
    host = _ref.host,
    homeUrl = _ref.homeUrl,
    variations = _ref.variations,
    skus = _ref.skus,
    givenStyleId = _ref.styleId,
    locationId = _ref.locationId,
    basisTranscoderPath = _ref.basisTranscoderPath,
    minFov = _ref.minFov,
    maxFov = _ref.maxFov,
    calculateFov = _ref.calculateFov,
    onFovChanged = _ref.onFovChanged,
    givenInitialCameraRotation = _ref.initialCameraRotation,
    givenOnCameraRotationChanged = _ref.onCameraRotationChanged,
    lookSpeed = _ref.lookSpeed,
    lookSpeedX = _ref.lookSpeedX,
    lookSpeedY = _ref.lookSpeedY,
    zoomSpeed = _ref.zoomSpeed,
    getErrorWidget = _ref.getErrorWidget;
    _ref.getLoadingWidget;
  var _LeRed$useState5 = LeRed.useState(false),
    _LeRed$useState6 = _slicedToArray(_LeRed$useState5, 2),
    movedCamera = _LeRed$useState6[0],
    setMovedCamera = _LeRed$useState6[1];
  var _useFadeoutAnimation = useFadeoutAnimation({
      visible: loading,
      delay: FADEOUT_DELAY_MS,
      duration: null,
      decayFactor: FADEOUT_DURATION_DECAY_FACTOR
    }),
    fadeoutOpacity = _useFadeoutAnimation.opacity;
  var opacity = 1 - fadeoutOpacity / (movedCamera ? 3 : 1);
  var controlsMultiplier = opacity < 0.8 ? 0 : 1;
  var opacityRef = LeRed.useRef();
  opacityRef.current = opacity;
  var _LeRed$useState7 = LeRed.useState(null),
    _LeRed$useState8 = _slicedToArray(_LeRed$useState7, 2),
    error = _LeRed$useState8[0],
    setError = _LeRed$useState8[1];
  var styleId = givenStyleId;
  var styles = variations === null || variations === void 0 ? void 0 : variations.styles;
  var locations = LeRed.useMemo(function () {
    var _variations$locations;
    return styleId ? variations === null || variations === void 0 || (_variations$locations = variations.locations) === null || _variations$locations === void 0 ? void 0 : _variations$locations.filter(function (location) {
      return LeUtils.contains(location === null || location === void 0 ? void 0 : location.supportedStyleIds, styleId);
    }) : variations === null || variations === void 0 ? void 0 : variations.locations;
  }, [variations === null || variations === void 0 ? void 0 : variations.locations, styleId]);
  var locationIndex = LeRed.useMemo(function () {
    return locationId ? LeUtils.findIndex(locations, function (location) {
      return (location === null || location === void 0 ? void 0 : location.locationId) === locationId;
    }) : 0;
  }, [locations, locationId]);
  if (!styleId) {
    var _locations$locationIn;
    styleId = STRING(locations === null || locations === void 0 || (_locations$locationIn = locations[locationIndex]) === null || _locations$locationIn === void 0 || (_locations$locationIn = _locations$locationIn.supportedStyleIds) === null || _locations$locationIn === void 0 ? void 0 : _locations$locationIn[0]);
  }
  var styleIndex = LeRed.useMemo(function () {
    return styleId ? LeUtils.findIndex(styles, function (style) {
      return (style === null || style === void 0 ? void 0 : style.styleId) === styleId;
    }) : 0;
  }, [styles, styleId]);
  var variationGroups = styles === null || styles === void 0 || (_styles$styleIndex = styles[styleIndex]) === null || _styles$styleIndex === void 0 ? void 0 : _styles$styleIndex.variationGroups;
  var locationVariationGroups = locations === null || locations === void 0 || (_locations$locationIn2 = locations[locationIndex]) === null || _locations$locationIn2 === void 0 ? void 0 : _locations$locationIn2.variationGroups;
  var selectedVariationIndexes = LeRed.useMemo(function () {
    return getSelectedVariationIndexesBySku(variationGroups, skus);
  }, [variationGroups, skus]);
  var src = LeRed.useMemo(function () {
    return getTexturePathsToRender(variationGroups, selectedVariationIndexes, locationVariationGroups, styleIndex, locationIndex, homeUrl);
  }, [variationGroups, selectedVariationIndexes, locationVariationGroups, styleIndex, locationIndex, homeUrl]);
  var initialCameraRotation = LeRed.useMemo(function () {
    var _location$recommended, _location$recommended2;
    if (ISSET(givenInitialCameraRotation === null || givenInitialCameraRotation === void 0 ? void 0 : givenInitialCameraRotation.yaw) && ISSET(givenInitialCameraRotation === null || givenInitialCameraRotation === void 0 ? void 0 : givenInitialCameraRotation.pitch)) {
      return givenInitialCameraRotation;
    }
    var location = locations === null || locations === void 0 ? void 0 : locations[locationIndex];
    if (ISSET(location === null || location === void 0 ? void 0 : location.desiredRotation)) {
      return {
        yaw: FLOAT_LAX(location === null || location === void 0 ? void 0 : location.desiredRotation),
        pitch: 0
      };
    }
    return {
      yaw: FLOAT_LAX(location === null || location === void 0 || (_location$recommended = location.recommendedRotation) === null || _location$recommended === void 0 ? void 0 : _location$recommended.yaw),
      pitch: FLOAT_LAX(location === null || location === void 0 || (_location$recommended2 = location.recommendedRotation) === null || _location$recommended2 === void 0 ? void 0 : _location$recommended2.pitch)
    };
  }, [givenInitialCameraRotation, locations === null || locations === void 0 || (_locations$locationIn3 = locations[locationIndex]) === null || _locations$locationIn3 === void 0 ? void 0 : _locations$locationIn3.desiredRotation, locations === null || locations === void 0 || (_locations$locationIn4 = locations[locationIndex]) === null || _locations$locationIn4 === void 0 ? void 0 : _locations$locationIn4.recommendedRotation]);
  var onCameraRotationChanged = LeRed.useCallback(function (newRotation) {
    if (opacityRef.current >= 0.8) {
      setMovedCamera(true);
    }
    givenOnCameraRotationChanged === null || givenOnCameraRotationChanged === void 0 || givenOnCameraRotationChanged(newRotation);
  }, [givenOnCameraRotationChanged]);
  var errorComponent = LeRed.useMemo(function () {
    if (error) {
      return getErrorWidget(error);
    }
    if (!styles || !locations) {
      return getErrorWidget({
        canRetry: false,
        id: 'could-not-connect-to-home',
        message: 'Couldn\'t connect to home: ' + homeId,
        reason: 'the home data isn\'t compatible with our frontend, it doesn\'t contain the information that should be in there',
        data: {
          homeId: homeId,
          host: host,
          homeUrl: homeUrl,
          variations: variations
        }
      });
    }
    if (styleId && locationId && (!ISSET(styleIndex) || !(styleIndex in styles) || !ISSET(locationIndex) || !(locationIndex in locations))) {
      return getErrorWidget({
        canRetry: false,
        id: 'invalid-location-and-style-id',
        message: 'Invalid location and style ID: ' + locationId + ' and ' + styleId,
        reason: 'the location and style ID combination doesn\'t exist in the home',
        data: {
          homeId: homeId,
          host: host,
          homeUrl: homeUrl,
          variations: variations,
          styleId: styleId,
          locationId: locationId
        }
      });
    }
    if (!ISSET(styleIndex) || !(styleIndex in styles)) {
      return getErrorWidget({
        canRetry: false,
        id: 'invalid-style-id',
        message: 'Invalid style ID: ' + styleId,
        reason: 'the style ID doesn\'t exist in the home',
        data: {
          homeId: homeId,
          host: host,
          homeUrl: homeUrl,
          variations: variations,
          styleId: styleId
        }
      });
    }
    if (!ISSET(locationIndex) || !(locationIndex in locations)) {
      return getErrorWidget({
        canRetry: false,
        id: 'invalid-location-id',
        message: 'Invalid location ID: ' + locationId,
        reason: 'the location ID doesn\'t exist in the home',
        data: {
          homeId: homeId,
          host: host,
          homeUrl: homeUrl,
          variations: variations,
          locationId: locationId
        }
      });
    }
    if (!variationGroups || !locationVariationGroups) {
      return getErrorWidget({
        canRetry: false,
        id: 'could-not-connect-to-home',
        message: 'Couldn\'t connect to home: ' + homeId,
        reason: 'the home data isn\'t compatible with our frontend, it doesn\'t contain the information that should be in there',
        data: {
          homeId: homeId,
          host: host,
          homeUrl: homeUrl,
          variations: variations
        }
      });
    }
  }, [error, styles, locations, styleId, locationId, styleIndex, locationIndex, variationGroups, locationVariationGroups, homeId, host, homeUrl, variations, getErrorWidget]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: _objectSpread({
      position: 'absolute',
      width: '100%',
      height: '100%',
      overflow: 'hidden'
    }, !loading ? {
      opacity: opacity
    } : {
      width: '1px',
      height: '1px',
      opacity: '0'
    })
  }, errorComponent || /*#__PURE__*/React.createElement(Canvas, {
    flat: true,
    linear: true,
    shadows: false,
    frameloop: "demand",
    gl: {
      precision: 'highp',
      antialias: false,
      depth: false,
      stencil: false
    }
  }, /*#__PURE__*/React.createElement(PerspectiveCamera, {
    makeDefault: true,
    position: [0, 0, 0]
  }), /*#__PURE__*/React.createElement(PanoramaControls, {
    minFov: minFov,
    maxFov: maxFov,
    calculateFov: calculateFov,
    onFovChanged: onFovChanged,
    initialCameraRotation: initialCameraRotation,
    onCameraRotationChanged: onCameraRotationChanged,
    lookSpeed: FLOAT_LAX_ANY(lookSpeed, 1) * controlsMultiplier,
    lookSpeedX: lookSpeedX,
    lookSpeedY: lookSpeedY,
    zoomSpeed: FLOAT_LAX_ANY(zoomSpeed, 1) * controlsMultiplier
  }), /*#__PURE__*/React.createElement(PanoramaRendererTexturePreloader, {
    src: src,
    homeId: homeId,
    host: host,
    homeUrl: homeUrl,
    basisTranscoderPath: basisTranscoderPath,
    setLoading: setLoading,
    setError: setError
  }))));
});

var _excluded$2 = ["src", "styleIndex", "locationIndex"];
var PanoramaLoaderVariationsParser = function PanoramaLoaderVariationsParser(_ref) {
  _ref.src;
    _ref.styleIndex;
    _ref.locationIndex;
    var props = _objectWithoutProperties(_ref, _excluded$2);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PanoramaRenderer, props));
};

/**
 * Returns the given props with corrected values.
 *
 * @param {Object} props
 * @returns {Object}
 */
var getCorrectedGivenProps = function getCorrectedGivenProps(props) {
  var result = {};
  LeUtils.each(props, function (value, key) {
    var newValue = value;
    switch (key) {
      case 'homeId':
      case 'locationId':
      case 'styleId':
        newValue = STRING(value).replace(/[^a-zA-Z0-9_]+/g, '');
        break;
      case 'homeVersion':
        newValue = (STRING(value).trim() || 'latest').toLowerCase();
        break;
      case 'host':
        newValue = STRING(value).trim() || 'https://d1i78mubvvqzk6.cloudfront.net';
        break;
      case 'minFov':
        newValue = Math.max(1, FLOAT_LAX_ANY(value, 20));
        break;
      case 'maxFov':
        newValue = Math.min(179, FLOAT_LAX_ANY(value, 130));
        break;
      case 'basisTranscoderPath':
        newValue = STRING(value).trim() || 'https://d11xh1fqz0z9k8.cloudfront.net/basis_transcoder/';
        break;
    }
    result[key] = newValue;
  });
  return result;
};

/**
 * Returns true if the given host is a private URL (like localhost, 127.0.0.1, etc).
 *
 * @param {string} host
 * @returns {boolean}
 */
var isHostPrivate = function () {
  var cache = {};
  return function (host) {
    if (!(host in cache)) {
      var hostLower = host.toLowerCase().trim();
      hostLower = hostLower.replace(/^[a-z]+:\/\//, '');
      hostLower = hostLower.replace(/[:/].*$/, '');
      cache[host] = LeUtils.isGivenHostPrivate(hostLower);
    }
    return cache[host];
  };
}();

/**
 * Fetches a JSON file, and caches the fetch promise (and the result).
 *
 * @param {string} url
 * @returns {Promise<*>}
 */
var fetchJsonCached = function () {
  var cachePromise = {};
  var cacheResult = {};
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            url = STRING(url);
            if (!(url in cachePromise)) {
              cachePromise[url] = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var _result$json;
                var result;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return LeUtils.fetch(url, {
                        retries: 3
                      });
                    case 2:
                      result = _context.sent;
                      _context.next = 5;
                      return result === null || result === void 0 || (_result$json = result.json) === null || _result$json === void 0 ? void 0 : _result$json.call(result);
                    case 5:
                      cacheResult[url] = _context.sent;
                      return _context.abrupt("return", cacheResult[url]);
                    case 7:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }))();
            }
            _context2.next = 4;
            return cachePromise[url];
          case 4:
            return _context2.abrupt("return", cacheResult[url]);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}();

/**
 * Returns the variation JSON data.
 *
 * If homeVersion is 'latest' (or null, or undefined), it will first fetch the latest version from the home.
 *
 * @param {Object} props
 * @param {string} props.homeId
 * @param {string|null} [props.homeVersion]
 * @param {string|null} [props.host]
 * @returns {Promise<{version:string, url:string, data:Object}>}
 */
var getVariationJsonData = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(props) {
    var givenHomeId, givenHomeVersion, givenHost, _getCorrectedGivenPro, homeId, homeVersion, host, homeUrl, latestData, variationData;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          givenHomeId = props.homeId, givenHomeVersion = props.homeVersion, givenHost = props.host;
          _getCorrectedGivenPro = getCorrectedGivenProps({
            homeId: givenHomeId,
            homeVersion: givenHomeVersion,
            host: givenHost
          }), homeId = _getCorrectedGivenPro.homeId, homeVersion = _getCorrectedGivenPro.homeVersion, host = _getCorrectedGivenPro.host;
          if (!isHostPrivate(host)) {
            _context3.next = 7;
            break;
          }
          homeVersion = 'latest';
          homeUrl = host + (host.endsWith('/') ? '' : '/');
          _context3.next = 15;
          break;
        case 7:
          if (!(homeVersion === 'latest')) {
            _context3.next = 14;
            break;
          }
          _context3.next = 10;
          return fetchJsonCached(host + '/' + homeId + '/latest.json');
        case 10:
          latestData = _context3.sent;
          if (!(!latestData || !(latestData !== null && latestData !== void 0 && latestData.version))) {
            _context3.next = 13;
            break;
          }
          throw new Error('the latest.json file doesn\'t contain a version number: ' + host + '/' + homeId + '/latest.json');
        case 13:
          homeVersion = latestData.version;
        case 14:
          homeUrl = host + '/' + homeId + '/' + homeVersion + '/';
        case 15:
          _context3.next = 17;
          return fetchJsonCached(homeUrl + 'variations.json');
        case 17:
          variationData = _context3.sent;
          if (variationData) {
            _context3.next = 20;
            break;
          }
          throw new Error('the variations.json file couldn\'t be load: ' + homeUrl + 'variations.json');
        case 20:
          return _context3.abrupt("return", {
            version: homeVersion,
            url: homeUrl,
            data: variationData
          });
        case 21:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getVariationJsonData(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Returns the variation JSON data.
 *
 * If homeVersion is 'latest' (or null, or undefined), it will first fetch the latest version from the home.
 *
 * @param {Object} props
 * @param {string} props.homeId
 * @param {string|null} [props.homeVersion]
 * @param {string|null} [props.host]
 * @returns [{version:string, url:string, data:Object}|null, boolean, string|null]
 */
var useVariationJsonData = function useVariationJsonData(props) {
  var homeId = props.homeId,
    homeVersion = props.homeVersion,
    host = props.host;
  return LeRed.usePromises(function () {
    return getVariationJsonData({
      homeId: homeId,
      homeVersion: homeVersion,
      host: host
    });
  }, [homeId, homeVersion, host]);
};

var _excluded$1 = ["variations", "homeVersion"];
var PanoramaLoaderVariationsRetriever = LeRed.memo(function (_ref) {
  _ref.variations;
    var givenHomeVersion = _ref.homeVersion,
    props = _objectWithoutProperties(_ref, _excluded$1);
  var homeId = props.homeId,
    host = props.host,
    getErrorWidget = props.getErrorWidget,
    getLoadingWidget = props.getLoadingWidget;
  var _useVariationJsonData = useVariationJsonData({
      homeId: homeId,
      homeVersion: givenHomeVersion,
      host: host
    }),
    _useVariationJsonData2 = _slicedToArray(_useVariationJsonData, 3),
    variations = _useVariationJsonData2[0],
    variationsLoading = _useVariationJsonData2[1],
    variationsError = _useVariationJsonData2[2];
  var errorComponent = LeRed.useMemo(function () {
    if (variationsLoading) {
      return null;
    }
    if (!(variations !== null && variations !== void 0 && variations.version) || !(variations !== null && variations !== void 0 && variations.url) || !(variations !== null && variations !== void 0 && variations.data)) {
      return getErrorWidget({
        canRetry: true,
        id: 'could-not-connect-to-home',
        message: 'Couldn\'t connect to home: ' + homeId,
        reason: STRING(variationsError),
        data: {
          homeId: homeId,
          homeVersion: givenHomeVersion,
          host: host
        }
      });
    }
  }, [variationsLoading, variations, variationsError, homeId, givenHomeVersion, host, getErrorWidget]);
  if (variationsLoading) {
    return getLoadingWidget();
  }
  if (errorComponent) {
    return errorComponent;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PanoramaLoaderVariationsParser, _extends({
    homeVersion: STRING(variations.version),
    homeUrl: STRING(variations.url),
    variations: variations.data
  }, props)));
});

var _excluded = ["homeId", "homeVersion", "host", "styleId", "locationId", "onError", "errorWidget", "loadingWidget", "minFov", "maxFov", "calculateFov", "basisTranscoderPath"];

/**
 * @exports
 * @typedef {Object} PanoramaViewerProps
 * @property {string} homeId
 * @property {string|null} [homeVersion]
 * @property {string|null} [host]
 * @property {string|null} [styleId]
 * @property {string|null} [locationId]
 * @property {Object.<string|symbol,string>|null} [skus]
 * @property {((error:{canRetry:boolean, retry:()=>void, message:string, reason:string, id:string, data:Object})=>void)|null} [onError]
 * @property {((error:{canRetry:boolean, retry:()=>void, message:string, reason:string, id:string, data:Object})=>import('react').ReactNode)|null} [errorWidget]
 * @property {(()=>import('react').ReactNode)|null} [loadingWidget]
 * @property {number|null} [minFov]
 * @property {number|null} [maxFov]
 * @property {((aspectRatio:number)=>number)|null} [calculateFov] The function to override how the field of view is calculated from the aspect ratio, for example:  (aspectRatio) => 109.22 - (16.69 * aspectRatio)
 * @property {((newFov:number)=>void)|null} [onFovChanged]
 * @property {{yaw:number, pitch:number}|null} [initialCameraRotation]
 * @property {((newRotation:{yaw:number, pitch:number})=>void)|null} [onCameraRotationChanged]
 * @property {number|null} [lookSpeed]
 * @property {number|null} [lookSpeedX]
 * @property {number|null} [lookSpeedY]
 * @property {number|null} [zoomSpeed]
 * @property {string|null} [basisTranscoderPath]
 */
/**
 * The PanoramaViewer component is the main component for rendering a panoramic home.
 *
 * @component
 * @type {import('react').FunctionComponent<PanoramaViewerProps>}
 */
var PanoramaViewer = LeRed.memo(function (props) {
  var givenHomeId = props.homeId,
    givenHomeVersion = props.homeVersion,
    givenHost = props.host,
    givenStyleId = props.styleId,
    givenLocationId = props.locationId,
    onError = props.onError,
    errorWidget = props.errorWidget,
    loadingWidget = props.loadingWidget,
    givenMinFov = props.minFov,
    givenMaxFov = props.maxFov,
    givenCalculateFov = props.calculateFov,
    givenBasisTranscoderPath = props.basisTranscoderPath,
    other = _objectWithoutProperties(props, _excluded);
  var _LeRed$useMemo = LeRed.useMemo(function () {
      return getCorrectedGivenProps({
        homeId: givenHomeId,
        homeVersion: givenHomeVersion,
        host: givenHost,
        styleId: givenStyleId,
        locationId: givenLocationId,
        basisTranscoderPath: givenBasisTranscoderPath
      });
    }, [givenHomeId, givenHomeVersion, givenHost, givenStyleId, givenLocationId, givenBasisTranscoderPath]),
    homeId = _LeRed$useMemo.homeId,
    homeVersion = _LeRed$useMemo.homeVersion,
    host = _LeRed$useMemo.host,
    locationId = _LeRed$useMemo.locationId,
    styleId = _LeRed$useMemo.styleId,
    basisTranscoderPath = _LeRed$useMemo.basisTranscoderPath;
  var _LeRed$useMemo2 = LeRed.useMemo(function () {
      return getCorrectedGivenProps({
        minFov: givenMinFov,
        maxFov: givenMaxFov
      });
    }, [givenMinFov, givenMaxFov]),
    minFov = _LeRed$useMemo2.minFov,
    maxFov = _LeRed$useMemo2.maxFov;
  var calculateFov = LeRed.useMemo(function () {
    return givenCalculateFov !== null && givenCalculateFov !== void 0 ? givenCalculateFov : function (aspectRatio) {
      return 299.36 / (aspectRatio + 2.37) - 1.35;
    };
  }, [givenCalculateFov]);
  var _LeRed$useState = LeRed.useState(LeUtils.uniqueId()),
    _LeRed$useState2 = _slicedToArray(_LeRed$useState, 2),
    attemptId = _LeRed$useState2[0],
    setAttemptId = _LeRed$useState2[1];
  var getErrorWidget = LeRed.useCallback(function (error) {
    var _error, _errorWidget;
    error = LeUtils.clone(error);
    if ((_error = error) !== null && _error !== void 0 && _error.canRetry) {
      error.retry = function () {
        setAttemptId(null);
        LeUtils.setAnimationFrameTimeout(function () {
          return setAttemptId(LeUtils.uniqueId());
        });
      };
    }
    console.error('[PanoramaViewer] Error: ', error);
    onError === null || onError === void 0 || onError(LeUtils.clone(error));
    return (_errorWidget = errorWidget === null || errorWidget === void 0 ? void 0 : errorWidget(LeUtils.clone(error))) !== null && _errorWidget !== void 0 ? _errorWidget : /*#__PURE__*/React.createElement(PanoramaDefaultErrorWidget, error);
  }, [onError, errorWidget, setAttemptId]);
  var getLoadingWidget = LeRed.useCallback(function () {
    var _loadingWidget;
    return (_loadingWidget = loadingWidget === null || loadingWidget === void 0 ? void 0 : loadingWidget()) !== null && _loadingWidget !== void 0 ? _loadingWidget : /*#__PURE__*/React.createElement(PanoramaDefaultLoadingWidget, null);
  }, [loadingWidget]);
  var errorComponent = LeRed.useMemo(function () {
    if (!isHostPrivate(host)) {
      if (!givenHomeId) {
        return getErrorWidget({
          canRetry: false,
          id: 'missing-home-id',
          message: 'Missing home ID',
          reason: 'the PanoramaViewer component was rendered without being given a valid home ID',
          data: {
            homeId: givenHomeId
          }
        });
      }
      if (homeId !== givenHomeId) {
        return getErrorWidget({
          canRetry: false,
          id: 'invalid-home-id',
          message: 'Invalid home ID: ' + givenHomeId,
          reason: 'the home ID contains invalid characters, only "a-z 0-9 _" is allowed',
          data: {
            homeId: givenHomeId
          }
        });
      }
      if (!homeId) {
        return getErrorWidget({
          canRetry: false,
          id: 'missing-home-id',
          message: 'Missing home ID',
          reason: 'the PanoramaViewer component was rendered without being given a valid home ID',
          data: {
            homeId: givenHomeId
          }
        });
      }
    }
    if (locationId && locationId !== givenLocationId) {
      return getErrorWidget({
        canRetry: false,
        id: 'invalid-location-id',
        message: 'Invalid location ID: ' + givenLocationId,
        reason: 'the location ID contains invalid characters, only "a-z 0-9 _" is allowed',
        data: {
          locationId: givenLocationId
        }
      });
    }
    if (styleId && styleId !== givenStyleId) {
      return getErrorWidget({
        canRetry: false,
        id: 'invalid-style-id',
        message: 'Invalid style ID: ' + givenStyleId,
        reason: 'the style ID contains invalid characters, only "a-z 0-9 _" is allowed',
        data: {
          styleId: givenStyleId
        }
      });
    }
  }, [homeId, givenHomeId, host, locationId, givenLocationId, styleId, givenStyleId, getErrorWidget]);
  if (errorComponent) {
    return errorComponent;
  }
  if (!attemptId) {
    return getLoadingWidget();
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PanoramaLoaderVariationsRetriever, _extends({
    homeId: homeId,
    homeVersion: homeVersion,
    host: host,
    styleId: styleId,
    locationId: locationId,
    basisTranscoderPath: basisTranscoderPath,
    minFov: minFov,
    maxFov: maxFov,
    calculateFov: calculateFov,
    getErrorWidget: getErrorWidget,
    getLoadingWidget: getLoadingWidget
  }, other)));
});

/**
 * Returns the version string of the home (unix timestamp, in millis).
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @returns {Promise<string>}
 */
var getHomeVersion = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var homeId, homeVersion, host, _yield$getVariationJs, version;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          homeId = params.homeId, homeVersion = params.homeVersion, host = params.host;
          _context.next = 3;
          return getVariationJsonData({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host
          });
        case 3:
          _yield$getVariationJs = _context.sent;
          version = _yield$getVariationJs.version;
          return _context.abrupt("return", STRING(version));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getHomeVersion(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Returns the version string of the home (unix timestamp, in millis).
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @returns {[string|null, boolean, string|null]}
 */
var useHomeVersion = function useHomeVersion(params) {
  var homeId = params.homeId,
    homeVersion = params.homeVersion,
    host = params.host;
  return LeRed.usePromises(function () {
    return getHomeVersion({
      homeId: homeId,
      homeVersion: homeVersion,
      host: host
    });
  }, [homeId, homeVersion, host]);
};

/**
 * Returns the version date of the home. Will return new Date(0) if the version timestamp is invalid.
 *
 * The version date is the date when the home panoramas were upload.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @returns {Promise<Date>}
 */
var getHomeVersionDate = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
    var homeId, homeVersion, host, versionInt, versionDate;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          homeId = params.homeId, homeVersion = params.homeVersion, host = params.host;
          _context2.t0 = INT_LAX;
          _context2.next = 4;
          return getHomeVersion({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host
          });
        case 4:
          _context2.t1 = _context2.sent;
          versionInt = (0, _context2.t0)(_context2.t1);
          if (!(versionInt <= 0)) {
            _context2.next = 8;
            break;
          }
          return _context2.abrupt("return", new Date(0));
        case 8:
          versionDate = new Date(versionInt);
          if (!(versionDate.toJSON() === null)) {
            _context2.next = 11;
            break;
          }
          return _context2.abrupt("return", new Date(0));
        case 11:
          return _context2.abrupt("return", versionDate);
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getHomeVersionDate(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Returns the version date of the home. Will return new Date(0) if the version timestamp is invalid.
 *
 * The version date is the date when the home panoramas were upload.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @returns {[Date|null, boolean, string|null]}
 */
var useHomeVersionDate = function useHomeVersionDate(params) {
  var homeId = params.homeId,
    homeVersion = params.homeVersion,
    host = params.host;
  return LeRed.usePromises(function () {
    return getHomeVersionDate({
      homeId: homeId,
      homeVersion: homeVersion,
      host: host
    });
  }, [homeId, homeVersion, host]);
};

/**
 * Returns the render date of the home. Will return new Date(0) if the render timestamp is invalid.
 *
 * The render date is the date when the home panoramas were rendered.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @returns {Promise<Date>}
 */
var getHomeRenderDate = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
    var homeId, homeVersion, host, _yield$getVariationJs2, variationData, renderDateInt, renderDate;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          homeId = params.homeId, homeVersion = params.homeVersion, host = params.host;
          _context3.next = 3;
          return getVariationJsonData({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host
          });
        case 3:
          _yield$getVariationJs2 = _context3.sent;
          variationData = _yield$getVariationJs2.data;
          renderDateInt = INT_LAX(variationData === null || variationData === void 0 ? void 0 : variationData.renderDate);
          if (!(renderDateInt <= 0)) {
            _context3.next = 8;
            break;
          }
          return _context3.abrupt("return", new Date(0));
        case 8:
          renderDate = new Date(renderDateInt);
          if (!(renderDate.toJSON() === null)) {
            _context3.next = 11;
            break;
          }
          return _context3.abrupt("return", new Date(0));
        case 11:
          return _context3.abrupt("return", renderDate);
        case 12:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getHomeRenderDate(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Returns the render date of the home. Will return new Date(0) if the render timestamp is invalid.
 *
 * The render date is the date when the home panoramas were rendered.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @returns {[Date|null, boolean, string|null]}
 */
var useHomeRenderDate = function useHomeRenderDate(params) {
  var homeId = params.homeId,
    homeVersion = params.homeVersion,
    host = params.host;
  return LeRed.usePromises(function () {
    return getHomeRenderDate({
      homeId: homeId,
      homeVersion: homeVersion,
      host: host
    });
  }, [homeId, homeVersion, host]);
};

/**
 * Returns an object with variation group IDs as keys, and arrays of SKUs as values.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @param {string|null} [params.locationId]
 * @returns {Promise<Object.<string|symbol,string[]>>}
 */
var getAvailableSkusGrouped = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
    var homeId, homeVersion, host, givenStyleId, givenLocationId, _getCorrectedGivenPro, styleId, locationId, _yield$getVariationJs3, variationData, onlyVariationStyleIds, onlyVariationGroupIds, result;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          homeId = params.homeId, homeVersion = params.homeVersion, host = params.host, givenStyleId = params.styleId, givenLocationId = params.locationId;
          _getCorrectedGivenPro = getCorrectedGivenProps({
            styleId: givenStyleId,
            locationId: givenLocationId
          }), styleId = _getCorrectedGivenPro.styleId, locationId = _getCorrectedGivenPro.locationId;
          _context4.next = 4;
          return getVariationJsonData({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host
          });
        case 4:
          _yield$getVariationJs3 = _context4.sent;
          variationData = _yield$getVariationJs3.data;
          onlyVariationStyleIds = null;
          onlyVariationGroupIds = null;
          if (locationId) {
            onlyVariationStyleIds = {};
            onlyVariationGroupIds = {};
            LeUtils.each(variationData === null || variationData === void 0 ? void 0 : variationData.locations, function (location) {
              if ((location === null || location === void 0 ? void 0 : location.locationId) === locationId) {
                LeUtils.each(location === null || location === void 0 ? void 0 : location.supportedStyleIds, function (styleId) {
                  if (styleId) {
                    onlyVariationStyleIds[styleId] = true;
                  }
                });
                LeUtils.each(location === null || location === void 0 ? void 0 : location.variationGroups, function (variationGroup) {
                  if (variationGroup !== null && variationGroup !== void 0 && variationGroup.groupId) {
                    onlyVariationGroupIds[variationGroup === null || variationGroup === void 0 ? void 0 : variationGroup.groupId] = true;
                  }
                  LeUtils.each(variationGroup === null || variationGroup === void 0 ? void 0 : variationGroup.layerDependencyGroupIds, function (layerDependencyGroupId) {
                    if (layerDependencyGroupId) {
                      onlyVariationGroupIds[layerDependencyGroupId] = true;
                    }
                  });
                });
              }
            });
          }
          result = {};
          LeUtils.each(variationData === null || variationData === void 0 ? void 0 : variationData.styles, function (style) {
            if ((!styleId || (style === null || style === void 0 ? void 0 : style.styleId) === styleId) && (onlyVariationStyleIds === null || (style === null || style === void 0 ? void 0 : style.styleId) in onlyVariationStyleIds)) {
              LeUtils.each(style === null || style === void 0 ? void 0 : style.variationGroups, function (variationGroup) {
                if (variationGroup !== null && variationGroup !== void 0 && variationGroup.groupId && (onlyVariationGroupIds === null || (variationGroup === null || variationGroup === void 0 ? void 0 : variationGroup.groupId) in onlyVariationGroupIds)) {
                  var _result$variationGrou;
                  var variationSkus = (_result$variationGrou = result[variationGroup === null || variationGroup === void 0 ? void 0 : variationGroup.groupId]) !== null && _result$variationGrou !== void 0 ? _result$variationGrou : [];
                  LeUtils.each(variationGroup === null || variationGroup === void 0 ? void 0 : variationGroup.variations, function (variation) {
                    if (variation !== null && variation !== void 0 && variation.sku && !variationSkus.includes(variation === null || variation === void 0 ? void 0 : variation.sku)) {
                      variationSkus.push(variation === null || variation === void 0 ? void 0 : variation.sku);
                    }
                  });
                  result[variationGroup === null || variationGroup === void 0 ? void 0 : variationGroup.groupId] = variationSkus;
                }
              });
            }
          });
          return _context4.abrupt("return", result);
        case 12:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getAvailableSkusGrouped(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * Returns an object with variation group IDs as keys, and arrays of SKUs as values.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @param {string|null} [params.locationId]
 * @returns {[Object.<string|symbol,string[]>|null, boolean, string|null]}
 */
var useAvailableSkusGrouped = function useAvailableSkusGrouped(params) {
  var homeId = params.homeId,
    homeVersion = params.homeVersion,
    host = params.host,
    styleId = params.styleId,
    locationId = params.locationId;
  return LeRed.usePromises(function () {
    return getAvailableSkusGrouped({
      homeId: homeId,
      homeVersion: homeVersion,
      host: host,
      styleId: styleId,
      locationId: locationId
    });
  }, [homeId, homeVersion, host, styleId, locationId]);
};

/**
 * Returns an array of SKUs.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @param {string|null} [params.locationId]
 * @returns {Promise<string[]>}
 */
var getAvailableSkus = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params) {
    var homeId, homeVersion, host, styleId, locationId, skusGrouped, result;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          homeId = params.homeId, homeVersion = params.homeVersion, host = params.host, styleId = params.styleId, locationId = params.locationId;
          _context5.next = 3;
          return getAvailableSkusGrouped({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host,
            styleId: styleId,
            locationId: locationId
          });
        case 3:
          skusGrouped = _context5.sent;
          result = [];
          LeUtils.each(skusGrouped, function (skus) {
            result.push.apply(result, _toConsumableArray(skus));
          });
          return _context5.abrupt("return", result);
        case 7:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function getAvailableSkus(_x5) {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * Returns an array of SKUs.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @param {string|null} [params.locationId]
 * @returns {[string[]|null, boolean, string|null]}
 */
var useAvailableSkus = function useAvailableSkus(params) {
  var homeId = params.homeId,
    homeVersion = params.homeVersion,
    host = params.host,
    styleId = params.styleId,
    locationId = params.locationId;
  return LeRed.usePromises(function () {
    return getAvailableSkus({
      homeId: homeId,
      homeVersion: homeVersion,
      host: host,
      styleId: styleId,
      locationId: locationId
    });
  }, [homeId, homeVersion, host, styleId, locationId]);
};

/**
 * Returns an array of style IDs.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.locationId]
 * @returns {Promise<string[]>}
 */
var getAvailableStyleIds = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(params) {
    var homeId, homeVersion, host, givenLocationId, _getCorrectedGivenPro2, locationId, _yield$getVariationJs4, variationData, location;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          homeId = params.homeId, homeVersion = params.homeVersion, host = params.host, givenLocationId = params.locationId;
          _getCorrectedGivenPro2 = getCorrectedGivenProps({
            locationId: givenLocationId
          }), locationId = _getCorrectedGivenPro2.locationId;
          _context6.next = 4;
          return getVariationJsonData({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host
          });
        case 4:
          _yield$getVariationJs4 = _context6.sent;
          variationData = _yield$getVariationJs4.data;
          location = LeUtils.find(variationData === null || variationData === void 0 ? void 0 : variationData.locations, function (location) {
            return (location === null || location === void 0 ? void 0 : location.locationId) === locationId;
          });
          return _context6.abrupt("return", LeUtils.filter(LeUtils.mapToArray(variationData === null || variationData === void 0 ? void 0 : variationData.styles, function (style) {
            return !location || LeUtils.contains(location === null || location === void 0 ? void 0 : location.supportedStyleIds, style === null || style === void 0 ? void 0 : style.styleId) ? STRING(style === null || style === void 0 ? void 0 : style.styleId) : null;
          })));
        case 8:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function getAvailableStyleIds(_x6) {
    return _ref6.apply(this, arguments);
  };
}();

/**
 * Returns an array of style IDs.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.locationId]
 * @returns {[string[]|null, boolean, string|null]}
 */
var useAvailableStyleIds = function useAvailableStyleIds(params) {
  var homeId = params.homeId,
    homeVersion = params.homeVersion,
    host = params.host,
    locationId = params.locationId;
  return LeRed.usePromises(function () {
    return getAvailableStyleIds({
      homeId: homeId,
      homeVersion: homeVersion,
      host: host,
      locationId: locationId
    });
  }, [homeId, homeVersion, host, locationId]);
};

/**
 * Returns an array of location IDs.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @returns {Promise<string[]>}
 */
var getAvailableLocationIds = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(params) {
    var homeId, homeVersion, host, givenStyleId, _getCorrectedGivenPro3, styleId, _yield$getVariationJs5, variationData;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          homeId = params.homeId, homeVersion = params.homeVersion, host = params.host, givenStyleId = params.styleId;
          _getCorrectedGivenPro3 = getCorrectedGivenProps({
            styleId: givenStyleId
          }), styleId = _getCorrectedGivenPro3.styleId;
          _context7.next = 4;
          return getVariationJsonData({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host
          });
        case 4:
          _yield$getVariationJs5 = _context7.sent;
          variationData = _yield$getVariationJs5.data;
          return _context7.abrupt("return", LeUtils.filter(LeUtils.mapToArray(variationData === null || variationData === void 0 ? void 0 : variationData.locations, function (location) {
            return !styleId || LeUtils.contains(location === null || location === void 0 ? void 0 : location.supportedStyleIds, styleId) ? STRING(location === null || location === void 0 ? void 0 : location.locationId) : null;
          })));
        case 7:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function getAvailableLocationIds(_x7) {
    return _ref7.apply(this, arguments);
  };
}();

/**
 * Returns an array of location IDs.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @returns {[string[]|null, boolean, string|null]}
 */
var useAvailableLocationIds = function useAvailableLocationIds(params) {
  var homeId = params.homeId,
    homeVersion = params.homeVersion,
    host = params.host,
    styleId = params.styleId;
  return LeRed.usePromises(function () {
    return getAvailableLocationIds({
      homeId: homeId,
      homeVersion: homeVersion,
      host: host,
      styleId: styleId
    });
  }, [homeId, homeVersion, host, styleId]);
};

/**
 * Returns the default selected SKUs for the given home.
 * Returns an object with variation group IDs as keys, and the default SKUs as values.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @param {string|null} [params.locationId]
 * @returns {Promise<Object.<string|symbol,string>>}
 */
var getDefaultSkusGrouped = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(params) {
    var homeId, homeVersion, host, givenStyleId, givenLocationId, _yield$getVariationJs6, variationData, _yield$getCurrentStyl, styleId, locationId, result;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          homeId = params.homeId, homeVersion = params.homeVersion, host = params.host, givenStyleId = params.styleId, givenLocationId = params.locationId;
          _context8.next = 3;
          return getVariationJsonData({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host
          });
        case 3:
          _yield$getVariationJs6 = _context8.sent;
          variationData = _yield$getVariationJs6.data;
          _context8.next = 7;
          return getCurrentStyleAndLocationId({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host,
            styleId: givenStyleId,
            locationId: givenLocationId
          });
        case 7:
          _yield$getCurrentStyl = _context8.sent;
          styleId = _yield$getCurrentStyl.styleId;
          locationId = _yield$getCurrentStyl.locationId;
          _context8.next = 12;
          return getAvailableSkusGrouped({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host,
            styleId: styleId,
            locationId: locationId
          });
        case 12:
          result = _context8.sent;
          return _context8.abrupt("return", LeUtils.map(result, function (skus, groupId) {
            var style = LeUtils.find(variationData === null || variationData === void 0 ? void 0 : variationData.styles, function (style) {
              return (style === null || style === void 0 ? void 0 : style.styleId) === styleId;
            });
            var variationGroup = LeUtils.find(style === null || style === void 0 ? void 0 : style.variationGroups, function (variationGroup) {
              return (variationGroup === null || variationGroup === void 0 ? void 0 : variationGroup.groupId) === groupId;
            });
            var defaultVariationIndex = INT_LAX(variationGroup === null || variationGroup === void 0 ? void 0 : variationGroup.defaultVariationIndex);
            return skus[defaultVariationIndex];
          }));
        case 14:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function getDefaultSkusGrouped(_x8) {
    return _ref8.apply(this, arguments);
  };
}();

/**
 * Returns the default selected SKUs for the given home.
 * Returns an object with variation group IDs as keys, and the default SKUs as values.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @param {string|null} [params.locationId]
 * @returns {[Object.<string|symbol,string>|null, boolean, string|null]}
 */
var useDefaultSkusGrouped = function useDefaultSkusGrouped(params) {
  var homeId = params.homeId,
    homeVersion = params.homeVersion,
    host = params.host,
    styleId = params.styleId,
    locationId = params.locationId;
  return LeRed.usePromises(function () {
    return getDefaultSkusGrouped({
      homeId: homeId,
      homeVersion: homeVersion,
      host: host,
      styleId: styleId,
      locationId: locationId
    });
  }, [homeId, homeVersion, host, styleId, locationId]);
};

/**
 * Returns the default selected SKUs for the given home.
 * Returns an array of SKUs.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @param {string|null} [params.locationId]
 * @returns {Promise<string[]>}
 */
var getDefaultSkus = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(params) {
    var homeId, homeVersion, host, styleId, locationId, skusGrouped, result;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          homeId = params.homeId, homeVersion = params.homeVersion, host = params.host, styleId = params.styleId, locationId = params.locationId;
          _context9.next = 3;
          return getDefaultSkusGrouped({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host,
            styleId: styleId,
            locationId: locationId
          });
        case 3:
          skusGrouped = _context9.sent;
          result = [];
          LeUtils.each(skusGrouped, function (skus) {
            result.push.apply(result, _toConsumableArray(skus));
          });
          return _context9.abrupt("return", result);
        case 7:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function getDefaultSkus(_x9) {
    return _ref9.apply(this, arguments);
  };
}();

/**
 * Returns the default selected SKUs for the given home.
 * Returns an array of SKUs.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @param {string|null} [params.locationId]
 * @returns {[string[]|null, boolean, string|null]}
 */
var useDefaultSkus = function useDefaultSkus(params) {
  var homeId = params.homeId,
    homeVersion = params.homeVersion,
    host = params.host,
    styleId = params.styleId,
    locationId = params.locationId;
  return LeRed.usePromises(function () {
    return getDefaultSkus({
      homeId: homeId,
      homeVersion: homeVersion,
      host: host,
      styleId: styleId,
      locationId: locationId
    });
  }, [homeId, homeVersion, host, styleId, locationId]);
};

/**
 * Returns the default selected style ID for the given home.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.locationId]
 * @returns {Promise<string>}
 */
var getDefaultStyleId = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(params) {
    var homeId, homeVersion, host, givenLocationId, _yield$getCurrentStyl2, styleId;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          homeId = params.homeId, homeVersion = params.homeVersion, host = params.host, givenLocationId = params.locationId;
          _context10.next = 3;
          return getCurrentStyleAndLocationId({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host,
            locationId: givenLocationId
          });
        case 3:
          _yield$getCurrentStyl2 = _context10.sent;
          styleId = _yield$getCurrentStyl2.styleId;
          _yield$getCurrentStyl2.locationId;
          return _context10.abrupt("return", styleId);
        case 7:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function getDefaultStyleId(_x10) {
    return _ref10.apply(this, arguments);
  };
}();

/**
 * Returns the default selected style ID for the given home.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.locationId]
 * @returns {[string|null, boolean, string|null]}
 */
var useDefaultStyleId = function useDefaultStyleId(params) {
  var homeId = params.homeId,
    homeVersion = params.homeVersion,
    host = params.host,
    locationId = params.locationId;
  return LeRed.usePromises(function () {
    return getDefaultStyleId({
      homeId: homeId,
      homeVersion: homeVersion,
      host: host,
      locationId: locationId
    });
  }, [homeId, homeVersion, host, locationId]);
};

/**
 * Returns the default selected location ID for the given home.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @returns {Promise<string>}
 */
var getDefaultLocationId = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(params) {
    var homeId, homeVersion, host, givenStyleId, _yield$getCurrentStyl3, locationId;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          homeId = params.homeId, homeVersion = params.homeVersion, host = params.host, givenStyleId = params.styleId;
          _context11.next = 3;
          return getCurrentStyleAndLocationId({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host,
            styleId: givenStyleId
          });
        case 3:
          _yield$getCurrentStyl3 = _context11.sent;
          _yield$getCurrentStyl3.styleId;
          locationId = _yield$getCurrentStyl3.locationId;
          return _context11.abrupt("return", locationId);
        case 7:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return function getDefaultLocationId(_x11) {
    return _ref11.apply(this, arguments);
  };
}();

/**
 * Returns the default selected location ID for the given home.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @returns {[string|null, boolean, string|null]}
 */
var useDefaultLocationId = function useDefaultLocationId(params) {
  var homeId = params.homeId,
    homeVersion = params.homeVersion,
    host = params.host,
    styleId = params.styleId;
  return LeRed.usePromises(function () {
    return getDefaultLocationId({
      homeId: homeId,
      homeVersion: homeVersion,
      host: host,
      styleId: styleId
    });
  }, [homeId, homeVersion, host, styleId]);
};

/**
 * Returns the currently selected SKUs for the given home.
 * Returns an object with variation group IDs as keys, and the current SKUs as values.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @param {string|null} [params.locationId]
 * @param {Object.<string|symbol,string>|null} [params.skus]
 * @param {boolean|null} [params.warnings]
 * @returns {Promise<Object.<string|symbol,string>>}
 */
var getCurrentSkusGrouped = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(params) {
    var homeId, homeVersion, host, givenStyleId, givenLocationId, skus, warnings, _yield$getVariationJs7, variationData, _yield$getCurrentStyl4, styleId, locationId, skuGroups, selectedSkuGroupIndex;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          homeId = params.homeId, homeVersion = params.homeVersion, host = params.host, givenStyleId = params.styleId, givenLocationId = params.locationId, skus = params.skus, warnings = params.warnings;
          _context12.next = 3;
          return getVariationJsonData({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host
          });
        case 3:
          _yield$getVariationJs7 = _context12.sent;
          variationData = _yield$getVariationJs7.data;
          _context12.next = 7;
          return getCurrentStyleAndLocationId({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host,
            styleId: givenStyleId,
            locationId: givenLocationId
          });
        case 7:
          _yield$getCurrentStyl4 = _context12.sent;
          styleId = _yield$getCurrentStyl4.styleId;
          locationId = _yield$getCurrentStyl4.locationId;
          _context12.next = 12;
          return getAvailableSkusGrouped({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host,
            styleId: styleId,
            locationId: locationId
          });
        case 12:
          skuGroups = _context12.sent;
          selectedSkuGroupIndex = LeUtils.mapToArray(skuGroups, function (skus, groupId) {
            var style = LeUtils.find(variationData === null || variationData === void 0 ? void 0 : variationData.styles, function (style) {
              return (style === null || style === void 0 ? void 0 : style.styleId) === styleId;
            });
            var variationGroup = LeUtils.find(style === null || style === void 0 ? void 0 : style.variationGroups, function (variationGroup) {
              return (variationGroup === null || variationGroup === void 0 ? void 0 : variationGroup.groupId) === groupId;
            });
            return INT_LAX(variationGroup === null || variationGroup === void 0 ? void 0 : variationGroup.defaultVariationIndex);
          });
          if (IS_ARRAY(skus)) {
            LeUtils.each(skus, function (sku) {
              var skuFound = false;
              LeUtils.each(skuGroups, function (skuGroup, groupId) {
                var skuGroupIndex = LeUtils.findIndex(skuGroup, function (skuGroupSku) {
                  return skuGroupSku === sku;
                });
                if (ISSET(skuGroupIndex)) {
                  selectedSkuGroupIndex[groupId] = skuGroupIndex;
                  skuFound = true;
                }
              });
              if (!skuFound && warnings) {
                console.warn('SKU not found:', sku);
              }
            });
          } else if (IS_OBJECT(skus)) {
            LeUtils.each(skus, function (sku, groupId) {
              var skuGroup = skuGroups[groupId];
              if (ISSET(skuGroup)) {
                var skuGroupIndex = LeUtils.findIndex(skuGroup, function (skuGroupSku) {
                  return skuGroupSku === sku;
                });
                if (ISSET(skuGroupIndex)) {
                  selectedSkuGroupIndex[groupId] = skuGroupIndex;
                } else if (warnings) {
                  console.warn('SKU not found in group:', sku, skuGroup);
                }
              } else if (warnings) {
                console.warn('SKU Group ID not found:', groupId);
              }
            });
          }
          return _context12.abrupt("return", LeUtils.map(skuGroups, function (skus, groupId) {
            return skus[selectedSkuGroupIndex[groupId]];
          }));
        case 16:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return function getCurrentSkusGrouped(_x12) {
    return _ref12.apply(this, arguments);
  };
}();

/**
 * Returns the currently selected SKUs for the given home.
 * Returns an object with variation group IDs as keys, and the current SKUs as values.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @param {string|null} [params.locationId]
 * @param {Object.<string|symbol,string>|null} [params.skus]
 * @param {boolean|null} [params.warnings]
 * @returns {[Object.<string|symbol,string>|null, boolean, string|null]}
 */
var useCurrentSkusGrouped = function useCurrentSkusGrouped(params) {
  var homeId = params.homeId,
    homeVersion = params.homeVersion,
    host = params.host,
    styleId = params.styleId,
    locationId = params.locationId,
    skus = params.skus,
    warnings = params.warnings;
  return LeRed.usePromises(function () {
    return getCurrentSkusGrouped({
      homeId: homeId,
      homeVersion: homeVersion,
      host: host,
      styleId: styleId,
      locationId: locationId,
      skus: skus,
      warnings: warnings
    });
  }, [homeId, homeVersion, host, styleId, locationId, skus, warnings]);
};

/**
 * Returns the currently selected SKUs for the given home.
 * Returns an array of SKUs.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @param {string|null} [params.locationId]
 * @param {Object.<string|symbol,string>|null} [params.skus]
 * @param {boolean|null} [params.warnings]
 * @returns {Promise<string[]>}
 */
var getCurrentSkus = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(params) {
    var homeId, homeVersion, host, styleId, locationId, skus, warnings, skuGroups, result;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          homeId = params.homeId, homeVersion = params.homeVersion, host = params.host, styleId = params.styleId, locationId = params.locationId, skus = params.skus, warnings = params.warnings;
          _context13.next = 3;
          return getCurrentSkusGrouped({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host,
            styleId: styleId,
            locationId: locationId,
            skus: skus,
            warnings: warnings
          });
        case 3:
          skuGroups = _context13.sent;
          result = [];
          LeUtils.each(skuGroups, function (skus) {
            result.push.apply(result, _toConsumableArray(skus));
          });
          return _context13.abrupt("return", result);
        case 7:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return function getCurrentSkus(_x13) {
    return _ref13.apply(this, arguments);
  };
}();

/**
 * Returns the currently selected SKUs for the given home.
 * Returns an array of SKUs.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @param {string|null} [params.locationId]
 * @param {Object.<string|symbol,string>|null} [params.skus]
 * @param {boolean|null} [params.warnings]
 * @returns {[string[]|null, boolean, string|null]}
 */
var useCurrentSkus = function useCurrentSkus(params) {
  var homeId = params.homeId,
    homeVersion = params.homeVersion,
    host = params.host,
    styleId = params.styleId,
    locationId = params.locationId,
    skus = params.skus,
    warnings = params.warnings;
  return LeRed.usePromises(function () {
    return getCurrentSkus({
      homeId: homeId,
      homeVersion: homeVersion,
      host: host,
      styleId: styleId,
      locationId: locationId,
      skus: skus,
      warnings: warnings
    });
  }, [homeId, homeVersion, host, styleId, locationId, skus, warnings]);
};

/**
 * Returns the currently selected style and location IDs for the given home.
 *
 * @internal
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @param {string|null} [params.locationId]
 * @returns {Promise<{styleId:string, locationId:string}>}
 */
var getCurrentStyleAndLocationId = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14(params) {
    var homeId, homeVersion, host, givenStyleId, givenLocationId, _yield$getVariationJs8, variationData, getStyleId, getLocationId, _getCorrectedGivenPro4, styleId, locationId;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          homeId = params.homeId, homeVersion = params.homeVersion, host = params.host, givenStyleId = params.styleId, givenLocationId = params.locationId;
          _context14.next = 3;
          return getVariationJsonData({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host
          });
        case 3:
          _yield$getVariationJs8 = _context14.sent;
          variationData = _yield$getVariationJs8.data;
          getStyleId = function getStyleId(_ref15) {
            var _ref15$locationId = _ref15.locationId,
              locationId = _ref15$locationId === void 0 ? undefined : _ref15$locationId;
            var location = !locationId ? null : LeUtils.find(variationData === null || variationData === void 0 ? void 0 : variationData.locations, function (location) {
              return (location === null || location === void 0 ? void 0 : location.locationId) === locationId;
            });
            var result = null;
            LeUtils.each(variationData === null || variationData === void 0 ? void 0 : variationData.styles, function (style) {
              if (!location || LeUtils.contains(location === null || location === void 0 ? void 0 : location.supportedStyleIds, style === null || style === void 0 ? void 0 : style.styleId)) {
                result = style === null || style === void 0 ? void 0 : style.styleId;
                return false;
              }
            });
            return STRING(result);
          };
          getLocationId = function getLocationId(_ref16) {
            var _ref16$styleId = _ref16.styleId,
              styleId = _ref16$styleId === void 0 ? undefined : _ref16$styleId;
            var style = !styleId ? null : LeUtils.find(variationData === null || variationData === void 0 ? void 0 : variationData.styles, function (style) {
              return (style === null || style === void 0 ? void 0 : style.styleId) === styleId;
            });
            var result = null;
            LeUtils.each(variationData === null || variationData === void 0 ? void 0 : variationData.locations, function (location) {
              if (!style || LeUtils.contains(location === null || location === void 0 ? void 0 : location.supportedStyleIds, styleId)) {
                result = location === null || location === void 0 ? void 0 : location.locationId;
                return false;
              }
            });
            return STRING(result);
          };
          _getCorrectedGivenPro4 = getCorrectedGivenProps({
            styleId: givenStyleId,
            locationId: givenLocationId
          }), styleId = _getCorrectedGivenPro4.styleId, locationId = _getCorrectedGivenPro4.locationId;
          if (!styleId || !locationId) {
            if (!styleId && !locationId) {
              styleId = getStyleId({});
            }
            if (styleId) {
              locationId = getLocationId({
                styleId: styleId
              });
            } else {
              styleId = getStyleId({
                locationId: locationId
              });
            }
          }
          return _context14.abrupt("return", {
            styleId: styleId,
            locationId: locationId
          });
        case 10:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return function getCurrentStyleAndLocationId(_x14) {
    return _ref14.apply(this, arguments);
  };
}();

/**
 * Returns the currently selected style ID for the given home.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @param {string|null} [params.locationId]
 * @returns {Promise<string>}
 */
var getCurrentStyleId = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15(params) {
    var homeId, homeVersion, host, givenStyleId, givenLocationId, _yield$getCurrentStyl5, styleId;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          homeId = params.homeId, homeVersion = params.homeVersion, host = params.host, givenStyleId = params.styleId, givenLocationId = params.locationId;
          _context15.next = 3;
          return getCurrentStyleAndLocationId({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host,
            styleId: givenStyleId,
            locationId: givenLocationId
          });
        case 3:
          _yield$getCurrentStyl5 = _context15.sent;
          styleId = _yield$getCurrentStyl5.styleId;
          _yield$getCurrentStyl5.locationId;
          return _context15.abrupt("return", styleId);
        case 7:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return function getCurrentStyleId(_x15) {
    return _ref17.apply(this, arguments);
  };
}();

/**
 * Returns the currently selected style ID for the given home.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @param {string|null} [params.locationId]
 * @returns {[string|null, boolean, string|null]}
 */
var useCurrentStyleId = function useCurrentStyleId(params) {
  var homeId = params.homeId,
    homeVersion = params.homeVersion,
    host = params.host,
    styleId = params.styleId,
    locationId = params.locationId;
  return LeRed.usePromises(function () {
    return getCurrentStyleId({
      homeId: homeId,
      homeVersion: homeVersion,
      host: host,
      styleId: styleId,
      locationId: locationId
    });
  }, [homeId, homeVersion, host, styleId, locationId]);
};

/**
 * Returns the currently selected location ID for the given home.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @param {string|null} [params.locationId]
 * @returns {Promise<string>}
 */
var getCurrentLocationId = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16(params) {
    var homeId, homeVersion, host, givenStyleId, givenLocationId, _yield$getCurrentStyl6, locationId;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          homeId = params.homeId, homeVersion = params.homeVersion, host = params.host, givenStyleId = params.styleId, givenLocationId = params.locationId;
          _context16.next = 3;
          return getCurrentStyleAndLocationId({
            homeId: homeId,
            homeVersion: homeVersion,
            host: host,
            styleId: givenStyleId,
            locationId: givenLocationId
          });
        case 3:
          _yield$getCurrentStyl6 = _context16.sent;
          _yield$getCurrentStyl6.styleId;
          locationId = _yield$getCurrentStyl6.locationId;
          return _context16.abrupt("return", locationId);
        case 7:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return function getCurrentLocationId(_x16) {
    return _ref18.apply(this, arguments);
  };
}();

/**
 * Returns the currently selected location ID for the given home.
 *
 * @param {Object} params
 * @param {string} params.homeId
 * @param {string|null} [params.homeVersion]
 * @param {string|null} [params.host]
 * @param {string|null} [params.styleId]
 * @param {string|null} [params.locationId]
 * @returns {[string|null, boolean, string|null]}
 */
var useCurrentLocationId = function useCurrentLocationId(params) {
  var homeId = params.homeId,
    homeVersion = params.homeVersion,
    host = params.host,
    styleId = params.styleId,
    locationId = params.locationId;
  return LeRed.usePromises(function () {
    return getCurrentLocationId({
      homeId: homeId,
      homeVersion: homeVersion,
      host: host,
      styleId: styleId,
      locationId: locationId
    });
  }, [homeId, homeVersion, host, styleId, locationId]);
};

export { PanoramaViewer, getAvailableLocationIds, getAvailableSkus, getAvailableSkusGrouped, getAvailableStyleIds, getCurrentLocationId, getCurrentSkus, getCurrentSkusGrouped, getCurrentStyleId, getDefaultLocationId, getDefaultSkus, getDefaultSkusGrouped, getDefaultStyleId, getHomeRenderDate, getHomeVersion, getHomeVersionDate, useAvailableLocationIds, useAvailableSkus, useAvailableSkusGrouped, useAvailableStyleIds, useCurrentLocationId, useCurrentSkus, useCurrentSkusGrouped, useCurrentStyleId, useDefaultLocationId, useDefaultSkus, useDefaultSkusGrouped, useDefaultStyleId, useHomeRenderDate, useHomeVersion, useHomeVersionDate };
//# sourceMappingURL=index.js.map
